/* INNAYA guide pages — shared behaviour + interactive tools.
   Everything is scoped to #inx-root and keyed off data attributes, so the
   page HTML stays plain markup that the Shopify page editor won't mangle. */
(function () {
  'use strict';
  var root = document.getElementById('inx-root');
  if (!root) return;
  root.classList.add('inx-js');

  var R = root.getAttribute('data-root') || '/';
  if (R.slice(-1) !== '/') R += '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem('inx:' + k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem('inx:' + k, JSON.stringify(v)); } catch (e) {} }
  };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || root.getAttribute('data-currency') || 'USD';
  }
  function money(cents, opts) {
    var cur = currency();
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', Object.assign({ style: 'currency', currency: cur }, opts || {})).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function num(v, d) { return Number(v).toLocaleString(undefined, { maximumFractionDigits: d == null ? 0 : d, minimumFractionDigits: d == null ? 0 : d }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- range fill ---------- */
  function paintRange(r) {
    var min = +r.min || 0, max = +r.max || 100, v = +r.value;
    r.style.setProperty('--p', ((v - min) / (max - min) * 100) + '%');
  }
  $$('.inx-range', root).forEach(function (r) { paintRange(r); r.addEventListener('input', function () { paintRange(r); }); });

  /* ---------- segmented buttons (generic) ---------- */
  function seg(el, onChange) {
    var btns = $$('button', el);
    btns.forEach(function (b) {
      b.type = 'button';
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (onChange) onChange(b.getAttribute('data-v'), b);
      });
    });
    var cur = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
    if (cur) cur.setAttribute('aria-pressed', 'true');
    return function () { var c = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0]; return c && c.getAttribute('data-v'); };
  }

  /* ---------- reveal on scroll ---------- */
  var revealEls = $$('[data-reveal]', root);
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else { revealEls.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- table of contents ---------- */
  var scope = $('[data-toc-scope]', root);
  if (scope) {
    var heads = $$('h2[id]', scope);
    var lists = $$('[data-toc]', root);
    lists.forEach(function (ol) {
      if (ol.children.length) return;
      ol.innerHTML = heads.map(function (h) {
        var label = h.getAttribute('data-toc-label') || h.textContent.replace(/\s+/g, ' ').trim();
        return '<li><a href="#' + h.id + '">' + esc(label) + '</a></li>';
      }).join('');
    });
    var links = $$('.inx-toc a, .inx-onpage a', root);
    if ('IntersectionObserver' in window && links.length) {
      var active = null;
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) active = e.target.id; });
        links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + active); });
      }, { rootMargin: '-10% 0px -75% 0px' });
      heads.forEach(function (h) { tio.observe(h); });
    }
  }

  /* ---------- toast ---------- */
  var toastEl;
  function toast(html, ms) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'inx-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 6500);
  }

  /* ---------- products (live price + add to cart) ---------- */
  var productCache = {};
  function fetchProduct(handle) {
    return fetch(R + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetchProduct(handle).catch(function () {
        return new Promise(function (res) { setTimeout(res, 1200); }).then(function () { return fetchProduct(handle); });
      });
    }
    return productCache[handle];
  }
  function addToCart(variantId, qty, props) {
    var item = { id: +variantId, quantity: qty || 1 };
    if (props) item.properties = props;
    return fetch(R + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to cart');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && j.sections && j.sections['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = j.sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp;
          bubble.innerHTML = inner.innerHTML;
        }
        return j;
      });
    });
  }
  function cartToast(title) {
    toast('<span><b>Added to cart</b><br>' + esc(title) + '</span><a class="alt" href="' + R + 'cart">View cart</a><a href="' + R + 'checkout">Checkout</a>');
  }
  window.INX = window.INX || {};
  window.INX.addToCart = addToCart;
  window.INX.getProduct = getProduct;
  window.INX.money = money;

  function variantLabel(v) { return v.title === 'Default Title' ? '' : v.title; }
  function plugGuess() {
    var c = ((window.Shopify && Shopify.country) || '').toUpperCase();
    if (c === 'GB' || c === 'IE') return 'UK';
    if (c === 'AU' || c === 'NZ') return 'AU';
    if (['US', 'CA', 'MX', 'PH', 'JP'].indexOf(c) > -1) return 'US';
    if (c) return 'EU';
    return 'US';
  }

  function renderCard(card) {
    var handle = card.getAttribute('data-inx-product');
    var mode = card.getAttribute('data-mode') || 'cart';
    var priceEl = $('.inx-pcard__price', card);
    var foot = $('.inx-pcard__foot', card);
    getProduct(handle).then(function (p) {
      var variants = p.variants || [];
      var pick = variants.filter(function (v) { return v.available; });
      var pref = card.getAttribute('data-prefer') || plugGuess();
      var initial = pick.filter(function (v) { return v.title === pref || v.title.replace(/[\u201d"]/g, '') === pref; })[0] || pick.filter(function (v) { return v.title === plugGuess(); })[0] || pick[0] || variants[0];
      function paint(v) {
        if (!priceEl || !v) return;
        var save = v.compare_at_price && v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
        priceEl.innerHTML = '<span>' + money(v.price) + '</span>' + (save ? '<s>' + money(v.compare_at_price) + '</s><span class="inx-save">Save ' + save + '%</span>' : '');
      }
      paint(initial);
      if (!foot) return;
      var url = R + 'products/' + handle;
      if (mode === 'link' || !initial) {
        foot.innerHTML = '<a class="inx-btn inx-btn--sky" href="' + url + '">' + esc(card.getAttribute('data-cta') || 'View details') + '</a>';
        return;
      }
      var html = '';
      if (variants.length > 1) {
        var label = card.getAttribute('data-variant-label') || (p.options && p.options[0] && p.options[0].name) || 'Option';
        html += '<label class="inx-sr" for="v-' + handle + '">' + esc(label) + '</label><select class="inx-select" id="v-' + handle + '">' +
          variants.map(function (v) { return '<option value="' + v.id + '"' + (v.id === initial.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(label) + ': ' + esc(variantLabel(v)) + (v.available ? '' : ' — sold out') + '</option>'; }).join('') + '</select>';
      }
      html += '<button type="button" class="inx-btn inx-btn--buy"' + (initial.available ? '' : ' disabled') + '>' + (initial.available ? esc(card.getAttribute('data-cta') || 'Add to cart') : 'Sold out') + '</button>';
      html += '<a class="inx-small inx-muted" style="text-align:center;text-decoration:underline" href="' + url + '">Full specs &amp; reviews</a>';
      foot.innerHTML = html;
      var sel = $('select', foot), btn = $('button', foot);
      var current = initial;
      if (sel) sel.addEventListener('change', function () {
        current = variants.filter(function (v) { return String(v.id) === sel.value; })[0];
        paint(current);
        btn.disabled = !current.available;
        btn.textContent = current.available ? (card.getAttribute('data-cta') || 'Add to cart') : 'Sold out';
      });
      btn.addEventListener('click', function () {
        var old = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
        addToCart(current.id, 1).then(function () {
          btn.textContent = 'Added ✓'; cartToast(p.title + (variantLabel(current) ? ' — ' + variantLabel(current) : ''));
          setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 2200);
        }).catch(function (err) {
          btn.textContent = old; btn.disabled = false;
          toast('<span><b>Couldn’t add that.</b><br>' + esc(err.message) + '</span><a href="' + url + '">Open product</a>');
        });
      });
    }).catch(function () {
      if (priceEl) priceEl.innerHTML = '<a class="inx-small inx-link" href="' + R + 'products/' + handle + '">See today\u2019s price</a>';
    });
  }
  $$('[data-inx-product]', root).forEach(renderCard);

  /* build a product card on the fly (used by tools that recommend products) */
  var CDN = 'https://cdn.shopify.com/s/files/1/0832/9835/3454/files/';
  var CARD_IMG = {
    'innaya-3d-advertising-hologram-fan': CDN + 'INNAYA_H16_3D_Advertising_Hologram_Fan_1.png',
    'innaya-h23-3d-advertising-hologram-fan': CDN + 'INNAYA_H23_3D_Advertising_Hologram_Fan.png',
    'innaya-h20-3d-advertising-hologram-fan': CDN + 'Inniya_H_39.jpg',
    'innaya-h-pro-3d-advertising-hologram-fan': CDN + 'Inniya_H_PRO_Life_Size.jpg',
    'innaya-g10-gobo-projector': CDN + 'INNAYA_G10_Waterproof_Outdoor_Logo_Projector.png'
  };
  function cardHTML(handle, role, note, mode, cta, prefer) {
    return '<div class="inx-pcard" data-inx-product="' + esc(handle) + '"' + (mode ? ' data-mode="' + esc(mode) + '"' : '') + (cta ? ' data-cta="' + esc(cta) + '"' : '') + (prefer ? ' data-prefer="' + esc(prefer) + '"' : '') + '>' +
      (role ? '<span class="inx-pcard__role">' + esc(role) + '</span>' : '') +
      '<a class="inx-pcard__img" href="' + R + 'products/' + esc(handle) + '"><img alt="" loading="lazy" width="600" height="600" data-fill-img></a>' +
      '<div class="inx-pcard__body"><a class="inx-pcard__title" href="' + R + 'products/' + esc(handle) + '" data-fill-title>&nbsp;</a>' +
      (note ? '<p class="inx-pcard__note">' + note + '</p>' : '') +
      '<div class="inx-pcard__price"><span class="inx-skel"></span></div><div class="inx-pcard__foot"></div></div></div>';
  }
  function mountCards(container) {
    $$('[data-inx-product]', container).forEach(function (card) {
      var h = card.getAttribute('data-inx-product');
      getProduct(h).then(function (p) {
        var im = $('[data-fill-img]', card), tt = $('[data-fill-title]', card);
        if (im && (CARD_IMG[h] || p.featured_image)) { var src = CARD_IMG[h] || p.featured_image; if (src.indexOf('//') === 0) src = 'https:' + src; im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600'; im.alt = p.title; }
        if (tt) tt.textContent = p.title;
      }).catch(function () {});
      renderCard(card);
    });
  }

  /* inline price spans: <span data-inx-price="handle" data-variant="60W"></span> */
  $$('[data-inx-price]', root).forEach(function (el) {
    getProduct(el.getAttribute('data-inx-price')).then(function (p) {
      var want = el.getAttribute('data-variant');
      var v = (want && p.variants.filter(function (x) { return x.title === want; })[0]) || p.variants[0];
      el.textContent = money(v.price);
    }).catch(function () {});
  });

  /* direct add buttons: <button data-inx-add="variantId" data-title="…"> */
  $$('[data-inx-add]', root).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var old = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(btn.getAttribute('data-inx-add'), 1).then(function () {
        cartToast(btn.getAttribute('data-title') || 'Item'); btn.innerHTML = old; btn.disabled = false;
      }).catch(function (e) { btn.innerHTML = old; btn.disabled = false; toast('<span><b>Couldn’t add that.</b><br>' + esc(e.message) + '</span>'); });
    });
  });

  /* ---------- tools registry ---------- */
  var T = {};
  window.INX.tools = T;
  window.INX.util = { $: $, $$: $$, clamp: clamp, store: store, money: money, num: num, esc: esc, seg: seg, paintRange: paintRange, toast: toast, reduceMotion: reduceMotion, addToCart: addToCart, cartToast: cartToast, getProduct: getProduct, R: R };

  
  /* ===== tool: 10-pov ===== */
  /* Persistence-of-vision simulator: shows how spinning LED blades paint a floating picture. */
  T.pov = function (el) {
    var cv = $('canvas[data-canvas]', el); if (!cv) return;
    var ctx = cv.getContext('2d');
    var N = 360, C = N / 2, RAD = 168, HUB = 14;
    var tgt = document.createElement('canvas'); tgt.width = tgt.height = N;
    var tctx = tgt.getContext('2d', { willReadFrequently: true });
    var buf = document.createElement('canvas'); buf.width = buf.height = N;
    var bctx = buf.getContext('2d');
    var img = bctx.createImageData(N, N);
    var disp = new Float32Array(N * N * 3);
    var rpmIn = $('[data-in="rpm"]', el), rpmOut = $('[data-out="rpm"]', el), verdict = $('[data-out="verdict"]', el);
    var art = 'logo', blades = 'on', angle = 0, last = 0, t0 = performance.now(), running = false, visible = true;
    var getArt = seg($('[data-in="art"]', el), function (v) { art = v; });
    var getBl = seg($('[data-in="blades"]', el), function (v) { blades = v; });
    art = getArt() || 'logo'; blades = getBl() || 'on';

    function drawTarget(t) {
      var g = tctx;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.fillStyle = '#000'; g.fillRect(0, 0, N, N);
      g.save(); g.translate(C, C);
      if (art === 'logo') {
        g.strokeStyle = 'rgba(164,206,222,.9)'; g.lineWidth = 3;
        g.beginPath(); g.arc(0, 0, 150, 0, Math.PI * 2); g.stroke();
        var sweep = ((t / 1600) % 1) * 460 - 230;
        var gr = g.createLinearGradient(sweep - 60, 0, sweep + 60, 0);
        gr.addColorStop(0, '#ffffff'); gr.addColorStop(0.5, '#a4cede'); gr.addColorStop(1, '#ffffff');
        g.fillStyle = gr; g.font = '700 58px Poppins, Arial, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle';
        g.fillText('INNAYA', 0, -6);
        g.fillStyle = '#ef6c00'; g.fillRect(-92, 34, 184 * (0.5 + 0.5 * Math.sin(t / 700)), 5);
        g.font = '500 17px Poppins, Arial, sans-serif'; g.fillStyle = '#a4cede';
        g.fillText('YOUR LOGO, IN MID-AIR', 0, 64);
      } else if (art === 'jelly') {
        var pulse = 1 + 0.08 * Math.sin(t / 380);
        var bell = g.createRadialGradient(0, -40, 10, 0, -30, 110);
        bell.addColorStop(0, '#ffd6f4'); bell.addColorStop(0.45, '#e05bd0'); bell.addColorStop(1, 'rgba(90,40,200,0)');
        g.fillStyle = bell;
        g.beginPath(); g.ellipse(0, -30, 92 * pulse, 70 / pulse, 0, Math.PI, 0); g.quadraticCurveTo(0, 10, -92 * pulse, -30); g.fill();
        g.lineWidth = 3; g.lineCap = 'round';
        for (var i = 0; i < 9; i++) {
          var x0 = -70 + i * 17.5;
          g.strokeStyle = i % 2 ? 'rgba(164,206,222,.95)' : 'rgba(255,140,230,.9)';
          g.beginPath(); g.moveTo(x0, -18);
          for (var y = 0; y <= 130; y += 6) g.lineTo(x0 + Math.sin(y / 22 + t / 420 + i) * (6 + y / 12), -18 + y);
          g.stroke();
        }
      } else {
        var sp = g.createRadialGradient(-28, -30, 8, 0, 0, 78);
        sp.addColorStop(0, '#ffe2b8'); sp.addColorStop(0.5, '#ef6c00'); sp.addColorStop(1, '#3b1600');
        g.save(); g.rotate(-0.35);
        g.strokeStyle = 'rgba(164,206,222,.55)'; g.lineWidth = 10;
        g.beginPath(); g.ellipse(0, 0, 138, 34, 0, Math.PI, Math.PI * 2); g.stroke();
        g.fillStyle = sp; g.beginPath(); g.arc(0, 0, 74, 0, Math.PI * 2); g.fill();
        g.strokeStyle = 'rgba(164,206,222,.95)'; g.lineWidth = 10;
        g.beginPath(); g.ellipse(0, 0, 138, 34, 0, 0, Math.PI); g.stroke();
        var mx = Math.cos(t / 900) * 150, my = Math.sin(t / 900) * 38;
        g.fillStyle = '#ffffff'; g.beginPath(); g.arc(mx, my, 9, 0, Math.PI * 2); g.fill();
        g.restore();
        g.fillStyle = '#ffffff';
        for (var s = 0; s < 22; s++) { var a = s * 2.39996, r = 60 + (s * 37) % 100; g.fillRect(Math.cos(a) * r * 1.5, Math.sin(a) * r * 1.5, 2, 2); }
      }
      g.restore();
      // everything outside the blade circle is unreachable
      return tctx.getImageData(0, 0, N, N).data;
    }

    function frame(now) {
      if (!running) return;
      var dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
      var rpm = +rpmIn.value;
      var data = drawTarget(now - t0);
      // persistence: ~90 ms time constant
      var decay = Math.exp(-dt / 0.09);
      for (var i = 0; i < disp.length; i++) disp[i] *= decay;
      var sweep = rpm / 60 * Math.PI * 2 * dt; // radians travelled this frame
      var steps = Math.max(1, Math.ceil(sweep / 0.014));
      var nb = 4, leds = 92;
      for (var s = 0; s < steps; s++) {
        var th = angle + sweep * (s / steps);
        for (var b = 0; b < nb; b++) {
          var a = th + b * Math.PI / 2, ca = Math.cos(a), sa = Math.sin(a);
          for (var k = 0; k < leds; k++) {
            var r = HUB + (RAD - HUB) * (k / (leds - 1));
            var x = (C + r * ca) | 0, y = (C + r * sa) | 0;
            if (x < 0 || y < 0 || x >= N || y >= N) continue;
            var p = (y * N + x), q = p * 4, d = p * 3;
            var R0 = data[q], G0 = data[q + 1], B0 = data[q + 2];
            if (R0 + G0 + B0 < 24) continue;
            if (disp[d] < R0) disp[d] = R0; if (disp[d + 1] < G0) disp[d + 1] = G0; if (disp[d + 2] < B0) disp[d + 2] = B0;
            var d2 = d + 3; if (x + 1 < N) { if (disp[d2] < R0) disp[d2] = R0; if (disp[d2 + 1] < G0) disp[d2 + 1] = G0; if (disp[d2 + 2] < B0) disp[d2 + 2] = B0; }
            var d3 = d + N * 3; if (y + 1 < N) { if (disp[d3] < R0) disp[d3] = R0; if (disp[d3 + 1] < G0) disp[d3 + 1] = G0; if (disp[d3 + 2] < B0) disp[d3 + 2] = B0; }
          }
        }
      }
      angle = (angle + sweep) % (Math.PI * 2);
      var o = img.data;
      for (var j = 0, m = 0; j < disp.length; j += 3, m += 4) { o[m] = disp[j]; o[m + 1] = disp[j + 1]; o[m + 2] = disp[j + 2]; o[m + 3] = 255; }
      bctx.putImageData(img, 0, 0);
      var W = cv.width, S = W / N;
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, W);
      ctx.imageSmoothingEnabled = true;
      ctx.drawImage(buf, 0, 0, W, W);
      // physical blades
      if (blades === 'on') {
        ctx.save(); ctx.translate(W / 2, W / 2);
        if (rpm > 420) {
          ctx.fillStyle = 'rgba(255,255,255,' + (0.035 + 0.02 * Math.random()) + ')';
          ctx.beginPath(); ctx.arc(0, 0, RAD * S, 0, Math.PI * 2); ctx.fill();
        } else {
          for (var bb = 0; bb < nb; bb++) {
            var aa = angle + bb * Math.PI / 2;
            ctx.strokeStyle = 'rgba(120,120,120,' + (rpm > 200 ? 0.35 : 0.8) + ')'; ctx.lineWidth = 7 * S;
            ctx.beginPath(); ctx.moveTo(Math.cos(aa) * HUB * S, Math.sin(aa) * HUB * S); ctx.lineTo(Math.cos(aa) * RAD * S, Math.sin(aa) * RAD * S); ctx.stroke();
          }
        }
        ctx.fillStyle = '#1b1b1b'; ctx.strokeStyle = '#444'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(0, 0, HUB * S, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.restore();
      }
      requestAnimationFrame(frame);
    }
    function say() {
      var rpm = +rpmIn.value;
      if (rpmOut) rpmOut.textContent = rpm + ' RPM';
      if (!verdict) return;
      var cls = 'inx-verdict ', msg;
      if (rpm === 0) { cls += 'is-bad'; msg = '<b>Stopped.</b> Four LED strips and nothing else. There is no picture yet, just hardware.'; }
      else if (rpm < 200) { cls += 'is-bad'; msg = '<b>Too slow.</b> Each strip paints one thin slice of the picture and it fades before the next slice arrives. You see spinning lines.'; }
      else if (rpm < 520) { cls += 'is-warn'; msg = '<b>Almost.</b> The slices start overlapping into a flickery, ghostly shape. Cheap fans that can’t hold speed look like this.'; }
      else { cls += 'is-good'; msg = '<b>Full speed.</b> Slices now arrive faster than your eye lets go of them, so they merge into one steady picture. The black areas are simply unlit, so you see straight through them. That’s the “floating” part.'; }
      verdict.className = cls; verdict.innerHTML = '<span class="inx-verdict__dot"></span><span>' + msg + '</span>';
    }
    rpmIn.addEventListener('input', say); say();
    function start() { if (!running && visible) { running = true; last = 0; requestAnimationFrame(frame); } }
    function stop() { running = false; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); else stop(); }, { threshold: 0.05 }).observe(el);
    } else start();
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  };

  /* ===== tool: 11-holo-finder ===== */
  /* Hologram projector finder: 4 questions -> honest recommendation. */
  T['holo-finder'] = function (el) {
    var ans = {};
    var out = $('[data-out="result"]', el);
    $$('[data-q]', el).forEach(function (q) {
      var key = q.getAttribute('data-q');
      $$('button', q).forEach(function (b) {
        b.type = 'button'; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          $$('button', q).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          ans[key] = b.getAttribute('data-v');
          decide();
        });
      });
    });
    var LINK = function (href, txt) { return '<a class="inx-link" href="' + R + href + '">' + txt + '</a>'; };
    function decide() {
      var need = ['place', 'dist', 'budget', 'show'].filter(function (k) { return !ans[k]; });
      if (need.length) {
        out.hidden = false;
        out.innerHTML = '<p class="inx-muted inx-small" style="margin:0">' + (4 - need.length) + ' of 4 answered. Keep going — the recommendation updates as you click.</p>';
        return;
      }
      var r = { tech: '', title: '', why: '', cards: [], extra: '' };
      var b = ans.budget, big = (b === 'b3' || b === 'b4');
      if (ans.place === 'stage' && (ans.show === 'person' || b === 'b4')) {
        r.tech = 'Pepper’s ghost (foil or glass)';
        r.title = 'You want a stage illusion, not a fan.';
        r.why = 'A full-size performer who appears to walk on stage is a Pepper’s ghost rig: angled foil, a hidden bright screen, and a dark room. We don’t sell those, and anyone quoting you under five figures is quoting a toy. If you need something portable that still gets gasps in a lobby or booth, a life-size fan stack is the practical cousin.';
        if (big) r.cards = [['innaya-h-pro-3d-advertising-hologram-fan', 'Portable alternative', '74-inch-tall image from three linked H23 fans.']];
      } else if (ans.place === 'outdoor') {
        r.tech = 'Gobo (logo) projector at night, fan only under cover';
        r.title = 'Outdoors, light beats spin.';
        r.why = 'Direct sun washes out every kind of hologram display. For outdoor branding after dark, an IP67 gobo projector throws your logo onto a wall or pavement and shrugs off rain. If you specifically need a floating image outside, keep a fan under an awning and out of reach. More on that in our ' + LINK('pages/gobo-projector', 'gobo projector guide') + '.';
        r.cards = [['innaya-g10-gobo-projector', 'Night + weather', 'Custom logo lens included. Upload your artwork on the product page.', 'link', 'Choose wattage & upload logo']];
      } else if (ans.show === 'person') {
        if (big) { r.tech = 'LED hologram fan, life-size stack'; r.title = 'Go life-size: the H-PRO.'; r.why = 'A believable person needs roughly 1.5 m of image height. The H-PRO splices three H23 fans on one bracket to give a 60 × 146 cm picture, which is the size that makes people stop and walk around it.'; r.cards = [['innaya-h-pro-3d-advertising-hologram-fan', 'Life-size', '3 × H23 fans, splicing router and bracket included.']]; }
        else { r.tech = 'LED hologram fan, large single unit'; r.title = 'Head-and-shoulders is realistic at this budget.'; r.why = 'A full-body figure isn’t realistic below about $1,500 with any honest technology. A 39-inch fan will carry a presenter from the chest up, or a product at close to real size, and you can link more fans later.'; r.cards = [['innaya-h20-3d-advertising-hologram-fan', 'Biggest single fan', '39-inch image, 1,184 LEDs.']]; }
      } else if (ans.place === 'home' && b === 'b1' && ans.show === 'decor') {
        r.tech = 'Window projector kit or pyramid (or a small fan)';
        r.title = 'For a one-night decoration, keep it cheap.';
        r.why = 'A window-projection kit (projector plus a sheer screen) is the budget pick for Halloween or Christmas at home, and phone pyramids are a fun toy. If you want the real “floating” effect that works with the lights on and every year after, a 16-inch fan is the step up.';
        r.cards = [['innaya-3d-advertising-hologram-fan', 'Step-up pick', '16-inch fan. Loads MP4 and JPG from its SD card or the app.']];
      } else if (ans.dist === 'far') {
        if (b === 'b4') { r.tech = 'LED hologram fan wall'; r.title = 'Across a hall, go wide: a fan wall.'; r.why = 'Past about 6 m, a single fan becomes a bright dot. Nine linked 65 cm fans make one 155 × 155 cm canvas, big enough to read from the back of an exhibition hall.'; r.cards = [['innaya-65cm-9-piece-3d-hologram-fan-wall', 'Hall-scale', 'Choose the 9-piece option for the full 155 × 155 cm wall.']]; }
        else if (big) { r.tech = 'LED hologram fan, large'; r.title = 'At distance, size matters most.'; r.why = 'For a 6–20 m audience, pick the largest single fan you can mount. The H39 is the biggest single unit we sell, and it links with more fans later if you grow.'; r.cards = [['innaya-h20-3d-advertising-hologram-fan', 'Long-range pick', '39-inch, 2,600 cd/m².'], ['innaya-h-pro-3d-advertising-hologram-fan', 'If budget stretches', 'Life-size stack.']]; }
        else { r.tech = 'LED hologram fan (mid) or a gobo projector'; r.title = 'Honest answer: a small fan won’t carry that far.'; r.why = 'At this budget a 23-inch fan carries short text to about 6 m and pictures to about 12 m. If your audience is further than that, a projected logo on a wall or floor will reach them for less. See the ' + LINK('pages/logo-projector', 'logo projector guide') + '.'; r.cards = [['innaya-h23-3d-advertising-hologram-fan', 'Best value', '23-inch, 4 blades.'], ['innaya-g10-gobo-projector', 'Longer reach', 'Projects a logo up to 16–25 m in the dark.', 'link', 'See the G10']]; }
      } else if (b === 'b1' || (ans.dist === 'near' && ans.show !== 'video')) {
        r.tech = 'LED hologram fan, compact';
        r.title = 'Start with the H16.';
        r.why = 'For counters, desks and small windows viewed from arm’s length, the 16-inch fan is plenty. It runs off a 12 V adapter, plays MP4 and JPG, and hangs on the included wall frame. It doesn’t link to other fans, so if you think you’ll want a bigger picture later, jump to the H23.';
        r.cards = [['innaya-3d-advertising-hologram-fan', 'Best starter', '16-inch, 2 blades, 16 GB card included.'], ['innaya-h23-3d-advertising-hologram-fan', 'If you’ll grow', 'Links with other fans via router.']];
      } else {
        r.tech = 'LED hologram fan, mid-size';
        r.title = 'The H23 is the one we’d buy.';
        r.why = 'Four blades and 720 LEDs make video look smooth rather than stripy, it pairs with Bluetooth speakers, mirrors your phone screen live, and it can be spliced with more H23s later for a bigger picture.' + (b === 'b3' || b === 'b4' ? ' With your budget, add the ceiling bracket and a protective case so it can go anywhere.' : '');
        r.cards = [['innaya-h23-3d-advertising-hologram-fan', 'Our pick', '23-inch, 4 blades, 2,200 cd/m².']];
        if (b === 'b3' || b === 'b4') r.cards.push(['h-series-vantage-plus-ceiling-hanging-bracket', 'Add-on', 'Hang it overhead, out of reach.', '', '', 'Models H16\u201d to H23\u201d'], ['h-series-projector-protective-shield', 'Add-on', 'Guard plus quieter running.', '', '', 'H23']);
      }
      out.hidden = false;
      out.innerHTML = '<div><span class="inx-card__tag">Recommended technology: ' + esc(r.tech) + '</span><h3 class="inx-h3" style="font-size:24px">' + esc(r.title) + '</h3><p class="inx-rec-why">' + r.why + '</p></div>' +
        (r.cards.length ? '<div class="inx-products ' + (r.cards.length > 2 ? 'inx-products--3' : '') + '" style="margin-top:6px">' + r.cards.map(function (c) { return cardHTML(c[0], c[1], c[2], c[3], c[4], c[5]); }).join('') + '</div>' : '');
      mountCards(out);
    }
    decide();
  };

  /* ===== tool: 20-throw-calc ===== */
  /* Gobo throw calculator: distance + light + wattage -> image size, verdict, side-view diagram. */
  T['throw-calc'] = function (el) {
    var dIn = $('[data-in="dist"]', el), dOut = $('[data-out="dist"]', el);
    var svg = $('svg[data-diagram]', el), res = $('[data-out="result"]', el), verdict = $('[data-out="verdict"]', el);
    var unit = store.get('unit', 'ft');
    var light = 'dusk', watt = '60';
    var RATIO = 0.33; // G10 lens: image width ~ one third of throw distance
    var RANGE = { '60': { dark: 16, dusk: 8, lit: 4 }, '110': { dark: 25, dusk: 12, lit: 6 } };
    var getU = seg($('[data-in="unit"]', el), function (v) { unit = v; store.set('unit', v); syncUnit(); });
    var getL = seg($('[data-in="light"]', el), function (v) { light = v; draw(); });
    var getW = seg($('[data-in="watt"]', el), function (v) { watt = v; draw(); });
    $$('[data-in="unit"] button', el).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === unit ? 'true' : 'false'); });
    light = getL() || light; watt = getW() || watt;
    var meters = 6;
    function fmt(m) { return unit === 'ft' ? num(m * 3.28084, m * 3.28084 < 10 ? 1 : 0) + ' ft' : num(m, m < 10 ? 1 : 0) + ' m'; }
    function syncUnit() {
      if (unit === 'ft') { dIn.min = 3; dIn.max = 82; dIn.step = 1; dIn.value = Math.round(meters * 3.28084); }
      else { dIn.min = 1; dIn.max = 25; dIn.step = 0.5; dIn.value = Math.round(meters * 2) / 2; }
      paintRange(dIn); draw();
    }
    dIn.addEventListener('input', function () { meters = unit === 'ft' ? +dIn.value / 3.28084 : +dIn.value; draw(); });
    function draw() {
      if (dOut) dOut.textContent = fmt(meters);
      var w = meters * RATIO;
      var max = RANGE[watt][light];
      var other = watt === '60' ? '110' : '60';
      var load = meters / max;
      // result tiles
      var areaTxt = unit === 'ft' ? num(Math.PI * Math.pow(w * 3.28084 / 2, 2), 0) + ' sq ft' : num(Math.PI * Math.pow(w / 2, 2), 1) + ' m²';
      res.innerHTML =
        '<div><small>Logo diameter</small><b>' + fmt(w) + '</b></div>' +
        '<div><small>Lit area</small><b>' + areaTxt + '</b></div>' +
        '<div><small>Rated reach, ' + watt + ' W</small><b>' + fmt(max) + '</b></div>' +
        '<div><small>Brightness headroom</small><b>' + (load <= 1 ? Math.round((1 - load) * 100) + '<em>%</em>' : 'None') + '</b></div>';
      var cls, msg;
      if (light === 'lit' && load > 1) { cls = 'is-bad'; msg = '<b>Too much light for this distance.</b> Gobos are projected light, so they compete with every lamp in the room. Move closer, dim the area, or project after dark.'; }
      else if (load > 1 && watt === '60' && meters <= RANGE['110'][light]) { cls = 'is-warn'; msg = '<b>Past the 60 W range.</b> The 110 W G10 reaches ' + fmt(RANGE['110'][light]) + ' in these conditions and will hold your logo crisp at ' + fmt(meters) + '.'; }
      else if (load > 1) { cls = 'is-bad'; msg = '<b>Beyond what either G10 is rated for.</b> Mount closer to the surface, or wait for full darkness, which roughly doubles the usable distance.'; }
      else if (load > 0.8) { cls = 'is-warn'; msg = '<b>Works, near the limit.</b> Expect a softer edge on thin lines. Keep artwork bold, or step up to ' + (watt === '60' ? 'the 110 W model.' : 'full darkness.'); }
      else { cls = 'is-good'; msg = '<b>Comfortable.</b> The ' + watt + ' W G10 has room to spare here. Your logo will be about ' + fmt(w) + ' across, ' + (w > 1.7 ? 'bigger than a person is tall.' : w > 0.9 ? 'about the width of a doorway.' : 'about the size of a doormat.'); }
      if (watt === '110' && load < 0.45 && light !== 'lit') msg += ' <span class="inx-muted">The 60 W version would also do this job for less.</span>';
      verdict.className = 'inx-verdict ' + cls;
      verdict.innerHTML = '<span class="inx-verdict__dot"></span><span>' + msg + '</span>';
      diagram(w, load);
    }
    function diagram(w, load) {
      if (!svg) return;
      var VW = 900, VH = 360, ground = 300;
      var glow = load > 1 ? '#7a7a7a' : '#a4cede';
      var alpha = Math.max(0.14, 0.6 - Math.min(load, 1.4) * 0.35);
      // ---- side view (left) ----
      var L = 40, Rside = 540;
      var sc = Math.min((Rside - L - 40) / Math.max(meters, 2.5), (ground - 40) / 3.4);
      var x2 = L + 20 + meters * sc, mountY = ground - 2.4 * sc;
      var cyM = Math.max(w / 2 + 0.15, 1.7), cy = ground - cyM * sc, half = (w / 2) * sc;
      var side =
        '<text x="' + L + '" y="26" fill="#8a8a8a" font-size="13" font-family="Oswald, sans-serif" letter-spacing="2">SIDE VIEW</text>' +
        '<line x1="0" y1="' + ground + '" x2="' + (Rside + 20) + '" y2="' + ground + '" stroke="#333"/>' +
        '<rect x="' + x2 + '" y="40" width="10" height="' + (ground - 40) + '" fill="#1f1f1f" stroke="#3a3a3a"/>' +
        '<polygon points="' + (L + 38) + ',' + mountY + ' ' + x2 + ',' + (cy - half) + ' ' + x2 + ',' + (cy + half) + '" fill="url(#beam)"/>' +
        '<line x1="' + x2 + '" y1="' + (cy - half) + '" x2="' + x2 + '" y2="' + (cy + half) + '" stroke="' + glow + '" stroke-width="4"/>' +
        '<line x1="' + (L + 20) + '" y1="' + ground + '" x2="' + (L + 20) + '" y2="' + mountY + '" stroke="#555" stroke-width="3"/>' +
        '<rect x="' + (L + 6) + '" y="' + (mountY - 9) + '" width="32" height="18" rx="3" fill="#2a2a2a" stroke="#777"/>' +
        '<circle cx="' + (L + 38) + '" cy="' + mountY + '" r="4" fill="#fff"/>' +
        '<line x1="' + (L + 20) + '" y1="' + (ground + 22) + '" x2="' + x2 + '" y2="' + (ground + 22) + '" stroke="#a4cede" stroke-width="1.5"/>' +
        '<line x1="' + (L + 20) + '" y1="' + (ground + 16) + '" x2="' + (L + 20) + '" y2="' + (ground + 28) + '" stroke="#a4cede" stroke-width="1.5"/>' +
        '<line x1="' + x2 + '" y1="' + (ground + 16) + '" x2="' + x2 + '" y2="' + (ground + 28) + '" stroke="#a4cede" stroke-width="1.5"/>' +
        '<text x="' + ((L + 20 + x2) / 2) + '" y="' + (ground + 48) + '" fill="#a4cede" font-size="15" font-family="Oswald, sans-serif" letter-spacing="1.5" text-anchor="middle">THROW ' + fmt(meters).toUpperCase() + '</text>';
      // ---- front view (right) ----
      var FX = 580, FW = 300, FY = 40, FH = ground - 40;
      var fs = Math.min((FH - 20) / Math.max(w * 1.15, 2.1), (FW - 40) / Math.max(w + 0.9, 2.2));
      var r = (w / 2) * fs, pcx = FX + FW / 2 + 0.35 * fs, pcy = ground - Math.max(w / 2 + 0.15, 1.7) * fs;
      if (pcy - r < FY + 6) pcy = FY + 6 + r;
      var ph = 1.75 * fs, px = pcx - r - 0.45 * fs;
      if (px < FX + 14) px = FX + 14;
      var front =
        '<text x="' + FX + '" y="26" fill="#8a8a8a" font-size="13" font-family="Oswald, sans-serif" letter-spacing="2">ON THE WALL</text>' +
        '<rect x="' + FX + '" y="' + FY + '" width="' + FW + '" height="' + FH + '" fill="#161616" stroke="#2c2c2c"/>' +
        '<circle cx="' + pcx + '" cy="' + pcy + '" r="' + (r + 10) + '" fill="url(#spot)"/>' +
        '<circle cx="' + pcx + '" cy="' + pcy + '" r="' + r + '" fill="none" stroke="' + glow + '" stroke-opacity="' + (alpha + 0.3) + '" stroke-width="3"/>' +
        '<text x="' + pcx + '" y="' + (pcy + Math.max(6, r * 0.18)) + '" fill="#fff" fill-opacity="' + Math.min(1, alpha + 0.45) + '" font-size="' + Math.max(12, r * 0.5) + '" font-weight="700" font-family="Poppins, sans-serif" text-anchor="middle">LOGO</text>' +
        '<g fill="#4a4a4a"><circle cx="' + px + '" cy="' + (ground - ph + ph * 0.07) + '" r="' + (ph * 0.07) + '"/><rect x="' + (px - ph * 0.09) + '" y="' + (ground - ph * 0.83) + '" width="' + (ph * 0.18) + '" height="' + (ph * 0.4) + '" rx="' + (ph * 0.05) + '"/><rect x="' + (px - ph * 0.08) + '" y="' + (ground - ph * 0.45) + '" width="' + (ph * 0.07) + '" height="' + (ph * 0.45) + '"/><rect x="' + (px + ph * 0.01) + '" y="' + (ground - ph * 0.45) + '" width="' + (ph * 0.07) + '" height="' + (ph * 0.45) + '"/></g>' +
        '<text x="' + (FX + FW / 2) + '" y="' + (ground + 48) + '" fill="#fff" font-size="15" font-family="Poppins, sans-serif" text-anchor="middle">' + fmt(w) + ' logo · ' + (unit === 'ft' ? '5 ft 9 in' : '1.75 m') + ' person</text>';
      svg.innerHTML =
        '<defs><linearGradient id="beam" x1="0" x2="1"><stop offset="0" stop-color="#fff" stop-opacity="' + (alpha + 0.15) + '"/><stop offset="1" stop-color="' + glow + '" stop-opacity="' + (alpha * 0.8) + '"/></linearGradient>' +
        '<radialGradient id="spot"><stop offset="0" stop-color="#fff" stop-opacity="' + Math.min(0.55, alpha) + '"/><stop offset=".75" stop-color="' + glow + '" stop-opacity="' + (alpha * 0.6) + '"/><stop offset="1" stop-color="' + glow + '" stop-opacity="0"/></radialGradient></defs>' +
        side + front;
    }
    syncUnit();
  };

  /* ===== tool: 30-gobo-studio ===== */
  /* Gobo preview studio: upload a logo, see it as a glass or steel gobo on real-looking surfaces.
     Steel mode finds "islands" (metal pieces that would fall out) so you know where bridges go.
     Everything runs locally in the browser; the file is never uploaded. */
  T['gobo-studio'] = function (el) {
    var stage = $('canvas[data-stage]', el), disc = $('canvas[data-disc]', el);
    if (!stage) return;
    var sctx = stage.getContext('2d'), dctx = disc ? disc.getContext('2d') : null;
    var SW = stage.width, SH = stage.height;
    var fileIn = $('input[type="file"]', el), drop = $('[data-drop]', el);
    var thrIn = $('[data-in="thr"]', el), blurIn = $('[data-in="blur"]', el), sizeIn = $('[data-in="size"]', el);
    var stats = $('[data-out="stats"]', el), note = $('[data-out="note"]', el), dl = $('[data-act="download"]', el);
    var steelOnly = $$('[data-steel-only]', el);
    var state = { type: 'glass', surface: 'brick', tint: '#ffffff', invert: false, sample: 'luna' };
    var N = 480; // working resolution for the artwork
    var art = document.createElement('canvas'); art.width = art.height = N;
    var actx = art.getContext('2d', { willReadFrequently: true });
    var light = document.createElement('canvas'); light.width = light.height = N;
    var lctx = light.getContext('2d');
    var surfaces = {};
    var srcImg = null;

    seg($('[data-in="type"]', el), function (v) { state.type = v; toggleSteel(); process(); });
    seg($('[data-in="surface"]', el), function (v) { state.surface = v; render(); });
    seg($('[data-in="invert"]', el), function (v) { state.invert = v === 'bg'; process(); });
    var sampleSeg = $('[data-in="sample"]', el);
    if (sampleSeg) seg(sampleSeg, function (v) { state.sample = v; srcImg = null; process(); });
    $$('[data-tint]', el).forEach(function (b) {
      b.type = 'button';
      b.addEventListener('click', function () {
        $$('[data-tint]', el).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        state.tint = b.getAttribute('data-tint'); process();
      });
    });
    [thrIn].forEach(function (i) { if (i) i.addEventListener('input', process); });
    [blurIn, sizeIn].forEach(function (i) { if (i) i.addEventListener('input', render); });
    function toggleSteel() { steelOnly.forEach(function (n) { n.hidden = state.type !== 'steel'; }); }
    toggleSteel();

    function loadFile(f) {
      if (!f || !/^image\//.test(f.type)) { if (note) note.textContent = 'That file isn’t an image. Try a PNG, JPG or SVG.'; return; }
      var url = URL.createObjectURL(f);
      var im = new Image();
      im.onload = function () { srcImg = im; if (note) note.textContent = 'Showing: ' + f.name + '. It stays on your device.'; process(); };
      im.onerror = function () { if (note) note.textContent = 'Couldn’t read that image. Try exporting it as a PNG.'; };
      im.src = url;
    }
    if (fileIn) fileIn.addEventListener('change', function () { loadFile(fileIn.files[0]); });
    if (drop) {
      drop.addEventListener('click', function () { fileIn && fileIn.click(); });
      drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileIn && fileIn.click(); } });
      ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) loadFile(f); });
    }

    /* ---- sample artwork (drawn, so there is no stock logo) ---- */
    function drawSample(g) {
      g.clearRect(0, 0, N, N);
      g.save(); g.translate(N / 2, N / 2);
      if (state.sample === 'luna') {
        g.fillStyle = '#f39a2b';
        g.beginPath(); g.arc(-8, -58, 58, 0, Math.PI * 2); g.fill();
        g.globalCompositeOperation = 'destination-out';
        g.beginPath(); g.arc(18, -74, 52, 0, Math.PI * 2); g.fill();
        g.globalCompositeOperation = 'source-over';
        g.fillStyle = '#ffffff'; g.textAlign = 'center'; g.textBaseline = 'middle';
        g.font = '700 54px Poppins, Arial, sans-serif'; g.fillText('LUNA', 0, 40);
        g.font = '500 20px Poppins, Arial, sans-serif'; g.fillStyle = '#a4cede'; g.fillText('CAFÉ · BAKERY', 0, 86);
      } else {
        g.strokeStyle = '#ffffff'; g.lineWidth = 9;
        g.beginPath(); g.arc(0, 0, 128, 0, Math.PI * 2); g.stroke();
        g.lineWidth = 3; g.beginPath(); g.arc(0, 0, 112, 0, Math.PI * 2); g.stroke();
        g.fillStyle = '#ffffff'; g.textAlign = 'center'; g.textBaseline = 'middle';
        g.font = '700 92px Georgia, "Times New Roman", serif'; g.fillText('O&A', 0, 4);
        g.font = '600 15px Poppins, Arial, sans-serif'; g.fillText('OAK · AND · ASH', 0, 74);
      }
      g.restore();
    }

    /* ---- turn the artwork into light (what passes through the gobo) ---- */
    var islandMask = null, islandCount = 0, colorCount = 0;
    function process() {
      actx.clearRect(0, 0, N, N);
      if (srcImg) {
        var iw = srcImg.naturalWidth || srcImg.width || N, ih = srcImg.naturalHeight || srcImg.height || N;
        var s = Math.min(N * 0.78 / iw, N * 0.78 / ih);
        actx.drawImage(srcImg, (N - iw * s) / 2, (N - ih * s) / 2, iw * s, ih * s);
      } else drawSample(actx);
      var id = actx.getImageData(0, 0, N, N), d = id.data;
      // background detection: opaque corners -> treat that colour as background
      var corners = [0, (N - 1) * 4, (N * (N - 1)) * 4, (N * N - 1) * 4], opaque = 0, br = 0, bg = 0, bb = 0;
      corners.forEach(function (q) { if (d[q + 3] > 200) { opaque++; br += d[q]; bg += d[q + 1]; bb += d[q + 2]; } });
      var hasBg = opaque >= 3; if (hasBg) { br /= opaque; bg /= opaque; bb /= opaque; }
      var ink = new Uint8Array(N * N);
      for (var i = 0, p = 0; i < d.length; i += 4, p++) {
        var a = d[i + 3];
        if (a < 110) continue;
        if (hasBg) { var dist = Math.abs(d[i] - br) + Math.abs(d[i + 1] - bg) + Math.abs(d[i + 2] - bb); if (dist < 70) continue; }
        ink[p] = 1;
      }
      var cx = N / 2, R = N * 0.47, R2 = R * R;
      var out = lctx.createImageData(N, N), o = out.data;
      var thr = thrIn ? +thrIn.value : 50;
      var tint = hex(state.tint);
      var buckets = {};
      for (var y = 0; y < N; y++) for (var x = 0; x < N; x++) {
        var k = y * N + x, q = k * 4, inside = (x - cx) * (x - cx) + (y - cx) * (y - cx) <= R2;
        var on;
        if (state.type === 'steel') {
          var lum = (d[q] * 0.3 + d[q + 1] * 0.59 + d[q + 2] * 0.11);
          var isInk = ink[k] && (hasBg ? true : lum >= thr * 2.2 || d[q + 3] > 200);
          on = inside && (state.invert ? !isInk : isInk);
          o[q] = on ? tint[0] : 0; o[q + 1] = on ? tint[1] : 0; o[q + 2] = on ? tint[2] : 0; o[q + 3] = 255;
        } else {
          on = inside && (state.invert ? !ink[k] : ink[k]);
          var r0 = state.invert ? 235 : d[q], g0 = state.invert ? 235 : d[q + 1], b0 = state.invert ? 235 : d[q + 2];
          // very dark artwork pixels would project as nothing; lift them so the logo still reads
          var mx = Math.max(r0, g0, b0); if (on && mx < 90) { r0 = g0 = b0 = 200; }
          o[q] = on ? r0 : 0; o[q + 1] = on ? g0 : 0; o[q + 2] = on ? b0 : 0; o[q + 3] = 255;
          if (on && !state.invert) { var key = (r0 >> 6) + '-' + (g0 >> 6) + '-' + (b0 >> 6); buckets[key] = (buckets[key] || 0) + 1; }
        }
      }
      lctx.putImageData(out, 0, 0);
      var total = 0; Object.keys(buckets).forEach(function (kk) { total += buckets[kk]; });
      colorCount = Object.keys(buckets).filter(function (kk) { return buckets[kk] > total * 0.03; }).length;
      // islands (steel only): metal not connected to the outer ring
      islandMask = null; islandCount = 0;
      if (state.type === 'steel') {
        var metal = new Uint8Array(N * N), seen = new Uint8Array(N * N), stack = [];
        for (var k2 = 0; k2 < N * N; k2++) {
          var xx = k2 % N, yy = (k2 / N) | 0, ins = (xx - cx) * (xx - cx) + (yy - cx) * (yy - cx) <= R2;
          metal[k2] = ins ? (o[k2 * 4] + o[k2 * 4 + 1] + o[k2 * 4 + 2] === 0 ? 1 : 0) : 1; // outside the disc is solid frame
        }
        for (var e = 0; e < N; e++) { [e, (N - 1) * N + e, e * N, e * N + N - 1].forEach(function (s0) { if (metal[s0] && !seen[s0]) { seen[s0] = 1; stack.push(s0); } }); }
        flood(stack, metal, seen);
        islandMask = new Uint8Array(N * N);
        var comp = new Uint8Array(N * N);
        for (var k3 = 0; k3 < N * N; k3++) {
          if (metal[k3] && !seen[k3] && !comp[k3]) {
            var size = 0, st = [k3]; comp[k3] = 1; var pix = [];
            while (st.length) { var c = st.pop(); size++; pix.push(c); var cxp = c % N;
              if (cxp > 0 && metal[c - 1] && !seen[c - 1] && !comp[c - 1]) { comp[c - 1] = 1; st.push(c - 1); }
              if (cxp < N - 1 && metal[c + 1] && !seen[c + 1] && !comp[c + 1]) { comp[c + 1] = 1; st.push(c + 1); }
              if (c >= N && metal[c - N] && !seen[c - N] && !comp[c - N]) { comp[c - N] = 1; st.push(c - N); }
              if (c < N * N - N && metal[c + N] && !seen[c + N] && !comp[c + N]) { comp[c + N] = 1; st.push(c + N); } }
            if (size > 18) { islandCount++; pix.forEach(function (pp) { islandMask[pp] = 1; }); }
          }
        }
      }
      render();
    }
    function flood(stack, metal, seen) {
      while (stack.length) {
        var c = stack.pop(), x = c % N;
        if (x > 0 && metal[c - 1] && !seen[c - 1]) { seen[c - 1] = 1; stack.push(c - 1); }
        if (x < N - 1 && metal[c + 1] && !seen[c + 1]) { seen[c + 1] = 1; stack.push(c + 1); }
        if (c >= N && metal[c - N] && !seen[c - N]) { seen[c - N] = 1; stack.push(c - N); }
        if (c < N * N - N && metal[c + N] && !seen[c + N]) { seen[c + N] = 1; stack.push(c + N); }
      }
    }
    function hex(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }

    /* ---- surfaces (procedural, cached) ---- */
    function rand(seed) { var s = seed; return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }; }
    function surface(name) {
      if (surfaces[name]) return surfaces[name];
      var c = document.createElement('canvas'); c.width = SW; c.height = SH; var g = c.getContext('2d'), rnd = rand(7);
      if (name === 'brick') {
        g.fillStyle = '#8a8378'; g.fillRect(0, 0, SW, SH);
        var bh = 34, bw = 92;
        for (var row = 0; row * bh < SH; row++) {
          var off = row % 2 ? -bw / 2 : 0;
          for (var col = -1; col * bw < SW + bw; col++) {
            var v = 0.8 + rnd() * 0.35;
            g.fillStyle = 'rgb(' + Math.round(150 * v) + ',' + Math.round(78 * v) + ',' + Math.round(58 * v) + ')';
            g.fillRect(col * bw + off + 3, row * bh + 3, bw - 6, bh - 6);
          }
        }
      } else if (name === 'sidewalk') {
        g.fillStyle = '#9a9a96'; g.fillRect(0, 0, SW, SH);
        for (var n = 0; n < 9000; n++) { var sh = 120 + rnd() * 70; g.fillStyle = 'rgba(' + sh + ',' + sh + ',' + (sh - 4) + ',.55)'; g.fillRect(rnd() * SW, rnd() * SH, 2, 2); }
        g.strokeStyle = 'rgba(40,40,40,.55)'; g.lineWidth = 3;
        for (var j = 0; j < 4; j++) { g.beginPath(); g.moveTo(j * SW / 3, 0); g.lineTo(j * SW / 3 + 40, SH); g.stroke(); }
        g.beginPath(); g.moveTo(0, SH * 0.55); g.lineTo(SW, SH * 0.52); g.stroke();
      } else if (name === 'floor') {
        var pw = 58;
        for (var px = 0; px < SW; px += pw) for (var py = -rnd() * 200; py < SH; py += 180 + rnd() * 120) {
          var tv = 0.85 + rnd() * 0.3;
          g.fillStyle = 'rgb(' + Math.round(176 * tv) + ',' + Math.round(128 * tv) + ',' + Math.round(84 * tv) + ')';
          g.fillRect(px, py, pw - 2, 300);
        }
        g.fillStyle = 'rgba(255,255,255,.06)'; g.fillRect(0, 0, SW, SH);
      } else {
        g.fillStyle = '#d9d4cb'; g.fillRect(0, 0, SW, SH);
        for (var m = 0; m < 5000; m++) { g.fillStyle = 'rgba(0,0,0,' + (rnd() * 0.05) + ')'; g.fillRect(rnd() * SW, rnd() * SH, 3, 3); }
      }
      surfaces[name] = c; return c;
    }

    /* ---- composite: surface x (ambient + projected light) ---- */
    var L = document.createElement('canvas'); L.width = SW; L.height = SH; var Lg = L.getContext('2d');
    function render() {
      var blur = blurIn ? +blurIn.value : 1, size = sizeIn ? +sizeIn.value / 100 : 0.72;
      var floorish = state.surface === 'sidewalk' || state.surface === 'floor';
      Lg.setTransform(1, 0, 0, 1, 0, 0);
      Lg.fillStyle = 'rgb(38,38,42)'; Lg.fillRect(0, 0, SW, SH); // night ambient
      Lg.save();
      Lg.translate(SW / 2, SH / 2);
      if (floorish) Lg.scale(1, 0.58);
      var D = SH * size * (floorish ? 1.45 : 1);
      Lg.filter = 'blur(' + blur + 'px)';
      Lg.globalCompositeOperation = 'lighter';
      Lg.drawImage(light, -D / 2, -D / 2, D, D);
      Lg.filter = 'none';
      // soft beam spill around the disc
      var gr = Lg.createRadialGradient(0, 0, D * 0.3, 0, 0, D * 0.62);
      gr.addColorStop(0, 'rgba(255,255,255,0.10)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
      Lg.fillStyle = gr; Lg.beginPath(); Lg.arc(0, 0, D * 0.62, 0, Math.PI * 2); Lg.fill();
      Lg.restore();
      Lg.globalCompositeOperation = 'source-over';
      sctx.globalCompositeOperation = 'source-over';
      sctx.drawImage(surface(state.surface), 0, 0);
      sctx.globalCompositeOperation = 'multiply';
      sctx.drawImage(L, 0, 0);
      sctx.globalCompositeOperation = 'screen';
      sctx.globalAlpha = 0.3; sctx.drawImage(L, 0, 0); sctx.globalAlpha = 1;
      sctx.globalCompositeOperation = 'source-over';
      // vignette
      var vg = sctx.createRadialGradient(SW / 2, SH / 2, SH * 0.3, SW / 2, SH / 2, SW * 0.7);
      vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,.55)');
      sctx.fillStyle = vg; sctx.fillRect(0, 0, SW, SH);
      drawDisc();
      say();
    }
    function drawDisc() {
      if (!dctx) return;
      var W = disc.width, c = W / 2, r = W * 0.47;
      dctx.clearRect(0, 0, W, W);
      if (state.type === 'steel') {
        var g = dctx.createLinearGradient(0, 0, W, W); g.addColorStop(0, '#9ea3a8'); g.addColorStop(1, '#5b6066');
        dctx.fillStyle = g; dctx.beginPath(); dctx.arc(c, c, W / 2 - 2, 0, Math.PI * 2); dctx.fill();
        // cut-outs = where light passes
        var tmp = document.createElement('canvas'); tmp.width = tmp.height = N; var t = tmp.getContext('2d');
        var src = lctx.getImageData(0, 0, N, N), sd = src.data, td = t.createImageData(N, N), tdd = td.data;
        for (var i = 0, p = 0; i < sd.length; i += 4, p++) {
          var passes = sd[i] + sd[i + 1] + sd[i + 2] > 0;
          if (passes) { tdd[i] = 10; tdd[i + 1] = 10; tdd[i + 2] = 12; tdd[i + 3] = 255; }
          else if (islandMask && islandMask[p]) { tdd[i] = 255; tdd[i + 1] = 80; tdd[i + 2] = 60; tdd[i + 3] = 255; }
        }
        t.putImageData(td, 0, 0);
        dctx.drawImage(tmp, 0, 0, W, W);
      } else {
        dctx.fillStyle = '#0c1a1f'; dctx.beginPath(); dctx.arc(c, c, W / 2 - 2, 0, Math.PI * 2); dctx.fill();
        dctx.drawImage(light, 0, 0, W, W);
        dctx.strokeStyle = 'rgba(164,206,222,.6)'; dctx.lineWidth = 3; dctx.beginPath(); dctx.arc(c, c, W / 2 - 3, 0, Math.PI * 2); dctx.stroke();
        var sh = dctx.createLinearGradient(0, 0, W, W); sh.addColorStop(0, 'rgba(255,255,255,.18)'); sh.addColorStop(0.5, 'rgba(255,255,255,0)');
        dctx.fillStyle = sh; dctx.beginPath(); dctx.arc(c, c, W / 2 - 2, 0, Math.PI * 2); dctx.fill();
      }
    }
    function say() {
      if (!stats) return;
      var html;
      if (state.type === 'steel') {
        html = '<li class="' + (islandCount ? 'warn' : 'ok') + '"><span><b>' + (islandCount ? islandCount + ' floating piece' + (islandCount > 1 ? 's' : '') : 'No floating pieces') + '.</b> ' +
          (islandCount ? 'Shown in red on the disc. In steel they would fall out, so a gobo maker adds thin bridges to hold them, and those bridges show up as fine dark lines in the projection.' : 'Everything connects to the outer ring, so this cuts cleanly in steel.') + '</span></li>' +
          '<li class="ok"><span><b>One color only.</b> Steel passes plain light. The color comes from the lamp or a gel, not the artwork.</span></li>';
      } else {
        html = '<li class="ok"><span><b>No bridges needed.</b> Glass holds every detail, including the insides of letters.</span></li>' +
          '<li class="' + (colorCount > 1 ? 'ok' : 'warn') + '"><span><b>' + (colorCount > 1 ? colorCount + ' colors detected.' : 'Single color artwork.') + '</b> ' + (colorCount > 1 ? 'Full-color glass reproduces these as they are.' : 'Fine in glass. Steel would also work and costs less.') + '</span></li>';
      }
      html += '<li class="' + (state.surface === 'brick' || state.surface === 'sidewalk' ? 'warn' : 'ok') + '"><span><b>' + ({ brick: 'Brick eats thin lines.', sidewalk: 'Concrete texture softens edges.', floor: 'Wood floors read well.', wall: 'Smooth walls are the sharpest.' })[state.surface] + '</b> ' + ({ brick: 'Keep text bold and larger on textured walls.', sidewalk: 'Bold shapes beat fine print underfoot.', floor: 'Expect a slight stretch from the angle.', wall: 'This is as crisp as a gobo gets.' })[state.surface] + '</span></li>';
      stats.innerHTML = html;
    }
    if (dl) dl.addEventListener('click', function () {
      try {
        var a = document.createElement('a'); a.download = 'innaya-gobo-preview.png'; a.href = stage.toDataURL('image/png'); document.body.appendChild(a); a.click(); a.remove();
      } catch (e) { toast('<span>Your browser blocked the download. Right-click the preview to save it.</span>'); }
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!srcImg) process(); });
    process();
  };

  /* ===== tool: 40-logo-planner ===== */
  /* Logo projector placement planner + running-cost calculator. */
  T['logo-planner'] = function (el) {
    var scene = $('svg[data-scene]', el), rec = $('[data-out="rec"]', el), cost = $('[data-out="cost"]', el);
    var hoursIn = $('[data-in="hours"]', el), rateIn = $('[data-in="rate"]', el), hoursOut = $('[data-out="hours"]', el), rateOut = $('[data-out="rate"]', el);
    var S = {
      sidewalk: { name: 'Sidewalk at your door', model: '60', mount: '3–4 m (10–13 ft) up, on the fascia or under the awning', throw: '3–5 m', size: '1–1.7 m (3–5.5 ft) wide', tips: ['Angle it so the logo lands just before the door, where people slow down.', 'Keep the beam off the street so drivers aren’t dazzled.', 'Bold marks read best on concrete. Skip small taglines.'] },
      facade: { name: 'The front of your building', model: '110', mount: 'On a pole or a neighboring wall, facing the facade', throw: '8–20 m', size: '2.5–6 m (8–20 ft) wide', tips: ['Mount as square-on to the wall as you can to avoid a stretched logo.', 'Use the 110 W model past about 8 m, or anywhere with streetlights.', 'Light-colored walls give the brightest result. Dark brick needs more power.'] },
      lobby: { name: 'Entrance or lobby floor', model: '60', mount: 'Ceiling or truss, 3–5 m up, pointing down', throw: '3–5 m', size: '1–1.7 m (3–5.5 ft) wide', tips: ['Straight down gives a perfect circle with no stretch.', 'Indoor lights compete. Keep it under 5 m, or dim nearby spots.', 'Matte floors show a logo better than polished marble.'] },
      wall: { name: 'Feature wall inside', model: '60', mount: 'Opposite wall or ceiling, above head height', throw: '2–6 m', size: '0.7–2 m (2–6 ft) wide', tips: ['Behind a reception desk or host stand is the classic spot.', 'Mount high enough that nobody walks through the beam.', 'Pair it with a dimmer or scene lighting if the room is bright.'] },
      lot: { name: 'Parking lot or drive-thru lane', model: '110', mount: 'Light pole or canopy, 4–6 m up', throw: '6–15 m', size: '2–5 m (6–16 ft) wide', tips: ['Arrows and “Order here” marks work as well as logos.', 'Check that the image isn’t in drivers’ eyelines.', 'At this distance, full dark matters. Put it on a dusk timer.'] }
    };
    var cur = 'sidewalk', model = '60';
    var PRICE = { '60': null, '110': null };
    getProduct('innaya-g10-gobo-projector').then(function (p) {
      p.variants.forEach(function (v) { if (/60/.test(v.title)) PRICE['60'] = v.price; if (/110/.test(v.title)) PRICE['110'] = v.price; });
      calc();
    }).catch(function () {});
    seg($('[data-in="place"]', el), function (v) { cur = v; model = S[v].model; syncModel(); draw(); calc(); });
    var getModel = seg($('[data-in="model"]', el), function (v) { model = v; calc(); });
    function syncModel() { $$('[data-in="model"] button', el).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === model ? 'true' : 'false'); }); }
    [hoursIn, rateIn].forEach(function (i) { if (i) i.addEventListener('input', calc); });

    function draw() {
      var s = S[cur];
      rec.innerHTML = '<span class="inx-card__tag">' + esc(s.name) + '</span>' +
        '<div class="inx-result" style="margin:10px 0 16px"><div><small>Suggested G10</small><b>' + s.model + ' W</b></div><div><small>Throw</small><b style="font-size:20px">' + s.throw + '</b></div><div><small>Logo size</small><b style="font-size:20px">' + s.size + '</b></div></div>' +
        '<p class="inx-small inx-muted" style="margin:0 0 10px"><b class="inx-w">Mount:</b> ' + esc(s.mount) + '</p>' +
        '<ul class="inx-check">' + s.tips.map(function (t) { return '<li class="ok"><span>' + esc(t) + '</span></li>'; }).join('') + '</ul>';
      scene.innerHTML = art(cur);
    }
    function calc() {
      var h = +hoursIn.value, rate = +rateIn.value / 100;
      if (hoursOut) hoursOut.textContent = h + ' h / night';
      if (rateOut) rateOut.textContent = '$' + rate.toFixed(2) + ' / kWh';
      var watts = model === '60' ? 70 : 130;
      var kwhMonth = watts * h * 30.4 / 1000;
      var energyMonth = kwhMonth * rate;
      var price = PRICE[model];
      var nights = 365 * 3;
      var perNight = price ? (price / 100 + energyMonth * 36) / nights : null;
      cost.innerHTML =
        '<div><small>Power per month</small><b>$' + energyMonth.toFixed(2) + '</b></div>' +
        '<div><small>Energy used</small><b>' + num(kwhMonth, 1) + '<em>kWh/mo</em></b></div>' +
        '<div><small>Cost per night over 3 yrs</small><b>' + (perNight ? '$' + perNight.toFixed(2) : '—') + '</b></div>';
    }
    function art(k) {
      var sky = '<rect width="600" height="340" fill="#07090c"/>';
      var glow = function (cx, cy, rx, ry) { return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '" fill="url(#lg)"/><text x="' + cx + '" y="' + (cy + ry * 0.22) + '" fill="#0b0b0b" fill-opacity=".55" font-family="Poppins, sans-serif" font-weight="700" font-size="' + Math.max(12, ry * 0.7) + '" text-anchor="middle" transform="translate(0 0)">LOGO</text>'; };
      var beam = function (x1, y1, x2a, y2a, x2b, y2b) { return '<polygon points="' + x1 + ',' + y1 + ' ' + x2a + ',' + y2a + ' ' + x2b + ',' + y2b + '" fill="url(#bm)"/>'; };
      var proj = function (x, y, r) { return '<g transform="translate(' + x + ',' + y + ') rotate(' + (r || 0) + ')"><rect x="-14" y="-8" width="28" height="16" rx="3" fill="#2b2b2b" stroke="#8a8a8a"/><circle cx="14" cy="0" r="4" fill="#fff"/></g>'; };
      var defs = '<defs><radialGradient id="lg"><stop offset="0" stop-color="#e9f6fb"/><stop offset=".6" stop-color="#a4cede" stop-opacity=".9"/><stop offset="1" stop-color="#a4cede" stop-opacity="0"/></radialGradient><linearGradient id="bm" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".35"/><stop offset="1" stop-color="#a4cede" stop-opacity=".05"/></linearGradient></defs>';
      var person = function (x, y, h) { return '<g fill="#2a2a2a"><circle cx="' + x + '" cy="' + (y - h + h * 0.08) + '" r="' + h * 0.08 + '"/><rect x="' + (x - h * 0.1) + '" y="' + (y - h * 0.82) + '" width="' + h * 0.2 + '" height="' + h * 0.42 + '" rx="' + h * 0.06 + '"/><rect x="' + (x - h * 0.09) + '" y="' + (y - h * 0.44) + '" width="' + h * 0.08 + '" height="' + h * 0.44 + '"/><rect x="' + (x + h * 0.01) + '" y="' + (y - h * 0.44) + '" width="' + h * 0.08 + '" height="' + h * 0.44 + '"/></g>'; };
      if (k === 'sidewalk') return defs + sky +
        '<rect x="0" y="250" width="600" height="90" fill="#26272a"/><rect x="0" y="244" width="600" height="8" fill="#3a3b3f"/>' +
        '<rect x="160" y="60" width="360" height="190" fill="#15171b" stroke="#2c2f35"/><rect x="190" y="110" width="140" height="140" fill="#2f3a3f"/><rect x="360" y="110" width="130" height="140" fill="#1f282c" stroke="#3b4a50"/>' +
        '<polygon points="150,60 530,60 510,88 170,88" fill="#1d2b31" stroke="#a4cede" stroke-opacity=".35"/>' +
        beam(200, 96, 250, 280, 430, 280) + proj(200, 96, 55) + glow(340, 285, 95, 26) + person(520, 300, 90) +
        '<text x="24" y="36" fill="#8a8a8a" font-family="Oswald, sans-serif" letter-spacing="2" font-size="14">STOREFRONT · NIGHT</text>';
      if (k === 'facade') return defs + sky +
        '<rect x="0" y="300" width="600" height="40" fill="#222"/><rect x="250" y="40" width="320" height="260" fill="#2b2e33"/>' +
        [0, 1, 2, 3].map(function (r) { return [0, 1, 2, 3, 4].map(function (c) { return '<rect x="' + (268 + c * 60) + '" y="' + (58 + r * 58) + '" width="34" height="30" fill="' + ((r + c) % 3 ? '#1a1d21' : '#4a4131') + '"/>'; }).join(''); }).join('') +
        '<line x1="60" y1="300" x2="60" y2="140" stroke="#555" stroke-width="4"/>' + beam(74, 140, 330, 90, 330, 250) + proj(62, 140, 0) + glow(410, 168, 92, 78) + person(150, 300, 70) +
        '<text x="24" y="36" fill="#8a8a8a" font-family="Oswald, sans-serif" letter-spacing="2" font-size="14">FACADE · FROM ACROSS THE LOT</text>';
      if (k === 'lobby') return defs + '<rect width="600" height="340" fill="#121315"/>' +
        '<polygon points="0,220 600,220 600,340 0,340" fill="#26241f"/><line x1="0" y1="220" x2="600" y2="220" stroke="#35322b"/>' +
        '<rect x="0" y="0" width="600" height="18" fill="#1b1c1f"/>' + beam(300, 22, 200, 290, 400, 290) + proj(300, 22, 90) + glow(300, 285, 115, 36) + person(470, 330, 120) + person(110, 330, 118) +
        '<text x="24" y="50" fill="#8a8a8a" font-family="Oswald, sans-serif" letter-spacing="2" font-size="14">LOBBY · FROM THE CEILING</text>';
      if (k === 'wall') return defs + '<rect width="600" height="340" fill="#18191c"/><rect x="0" y="280" width="600" height="60" fill="#232323"/>' +
        '<rect x="200" y="210" width="220" height="70" fill="#2a2b2f" stroke="#3a3b40"/>' + beam(40, 40, 310, 60, 310, 190) + proj(40, 40, 18) + glow(310, 125, 70, 66) + person(470, 300, 110) +
        '<text x="24" y="330" fill="#8a8a8a" font-family="Oswald, sans-serif" letter-spacing="2" font-size="14">RECEPTION · FEATURE WALL</text>';
      return defs + sky + '<rect x="0" y="220" width="600" height="120" fill="#1d1e21"/>' +
        [0, 1, 2, 3, 4].map(function (i) { return '<line x1="' + (60 + i * 120) + '" y1="232" x2="' + (30 + i * 130) + '" y2="340" stroke="#e8e0b0" stroke-opacity=".35" stroke-width="3"/>'; }).join('') +
        '<line x1="520" y1="330" x2="520" y2="70" stroke="#555" stroke-width="5"/>' + beam(508, 76, 180, 250, 380, 300) + proj(508, 76, 150) + glow(290, 280, 110, 32) +
        '<text x="24" y="36" fill="#8a8a8a" font-family="Oswald, sans-serif" letter-spacing="2" font-size="14">PARKING LOT · FROM A POLE</text>';
    }
    draw(); calc();
  };

  /* ===== tool: 50-monogram ===== */
  /* Wedding monogram designer: initials + names + date + frame, previewed as a gobo on a dance floor. */
  T.monogram = function (el) {
    var stage = $('canvas[data-stage]', el); if (!stage) return;
    var ctx = stage.getContext('2d'), SW = stage.width, SH = stage.height;
    var inI = $('[data-in="initials"]', el), inN = $('[data-in="names"]', el), inD = $('[data-in="date"]', el);
    var sizeIn = $('[data-in="size"]', el);
    var st = { frame: 'wreath', font: 'script', surface: 'wood', color: '#fff4de' };
    var N = 800, art = document.createElement('canvas'); art.width = art.height = N; var a = art.getContext('2d');
    var FONTS = { script: '"Great Vibes", "Brush Script MT", cursive', serif: '"Playfair Display", Georgia, serif', modern: 'Poppins, Arial, sans-serif' };
    // load the two display fonts only on this page
    if (!document.getElementById('inx-mono-fonts')) {
      var l = document.createElement('link'); l.id = 'inx-mono-fonts'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Great+Vibes&family=Playfair+Display:ital,wght@0,600;1,500&display=swap';
      document.head.appendChild(l);
    }
    seg($('[data-in="frame"]', el), function (v) { st.frame = v; draw(); });
    seg($('[data-in="font"]', el), function (v) { st.font = v; draw(); });
    seg($('[data-in="surface"]', el), function (v) { st.surface = v; draw(); });
    $$('[data-tint]', el).forEach(function (b) {
      b.type = 'button';
      b.addEventListener('click', function () { $$('[data-tint]', el).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); st.color = b.getAttribute('data-tint'); draw(); });
    });
    [inI, inN, inD].forEach(function (i) { if (i) i.addEventListener('input', draw); });
    if (sizeIn) sizeIn.addEventListener('input', draw);

    function leaf(g, x, y, ang, len) {
      g.save(); g.translate(x, y); g.rotate(ang);
      g.beginPath(); g.moveTo(0, 0); g.quadraticCurveTo(len * 0.5, -len * 0.32, len, 0); g.quadraticCurveTo(len * 0.5, len * 0.32, 0, 0); g.fill(); g.restore();
    }
    function drawArt() {
      var g = a, C = N / 2;
      g.clearRect(0, 0, N, N); g.fillStyle = '#fff'; g.strokeStyle = '#fff'; g.textAlign = 'center'; g.textBaseline = 'middle';
      var ini = (inI.value || 'A&J').trim().slice(0, 5), names = (inN.value || '').trim().slice(0, 34), date = (inD.value || '').trim().slice(0, 20);
      // frame
      if (st.frame === 'wreath') {
        g.lineWidth = 5; g.beginPath(); g.arc(C, C, 300, Math.PI * 0.62, Math.PI * 2.38); g.stroke();
        for (var i = 0; i < 44; i++) {
          var t = Math.PI * 0.64 + i * (Math.PI * 1.72 / 43), r = 300, x = C + Math.cos(t) * r, y = C + Math.sin(t) * r;
          leaf(g, x, y, t + Math.PI / 2 + (i % 2 ? 0.7 : -0.7), 34);
        }
      } else if (st.frame === 'ring') {
        g.lineWidth = 9; g.beginPath(); g.arc(C, C, 318, 0, Math.PI * 2); g.stroke();
        g.lineWidth = 3; g.beginPath(); g.arc(C, C, 294, 0, Math.PI * 2); g.stroke();
        for (var d2 = 0; d2 < 4; d2++) { var tt = d2 * Math.PI / 2 + Math.PI / 4; g.beginPath(); g.arc(C + Math.cos(tt) * 306, C + Math.sin(tt) * 306, 8, 0, Math.PI * 2); g.fill(); }
      } else if (st.frame === 'deco') {
        g.lineWidth = 4;
        for (var k = 0; k < 48; k++) { var an = k * Math.PI * 2 / 48, r1 = k % 2 ? 300 : 284, r2 = 330; g.beginPath(); g.moveTo(C + Math.cos(an) * r1, C + Math.sin(an) * r1); g.lineTo(C + Math.cos(an) * r2, C + Math.sin(an) * r2); g.stroke(); }
        g.lineWidth = 6; g.beginPath(); g.arc(C, C, 272, 0, Math.PI * 2); g.stroke();
      }
      // initials
      var fam = FONTS[st.font];
      var big = st.font === 'script' ? 230 : st.font === 'serif' ? 190 : 170;
      var weight = st.font === 'modern' ? '600 ' : st.font === 'serif' ? 'italic 500 ' : '';
      g.font = weight + big + 'px ' + fam;
      while (g.measureText(ini).width > 470 && big > 60) { big -= 8; g.font = weight + big + 'px ' + fam; }
      g.fillText(ini, C, C - (names || date ? 36 : 0));
      // names and date
      if (names) { var ns = 44; g.font = (st.font === 'modern' ? '500 ' : 'italic 500 ') + ns + 'px ' + (st.font === 'modern' ? FONTS.modern : FONTS.serif); while (g.measureText(names).width > 460 && ns > 20) { ns -= 2; g.font = (st.font === 'modern' ? '500 ' : 'italic 500 ') + ns + 'px ' + (st.font === 'modern' ? FONTS.modern : FONTS.serif); } g.fillText(names, C, C + 120); }
      if (date) { g.font = '500 30px Oswald, Poppins, sans-serif'; if (g.letterSpacing !== undefined) g.letterSpacing = '6px'; g.fillText(date.toUpperCase(), C, C + (names ? 176 : 130)); if (g.letterSpacing !== undefined) g.letterSpacing = '0px'; }
    }
    var tint = document.createElement('canvas'); tint.width = tint.height = N; var tg = tint.getContext('2d');
    var surf = {};
    function rnd(seed) { var s = seed; return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }; }
    function surface(name) {
      if (surf[name]) return surf[name];
      var c = document.createElement('canvas'); c.width = SW; c.height = SH; var g = c.getContext('2d'), r = rnd(11);
      if (name === 'wood') {
        for (var x = 0; x < SW; x += 64) for (var y = -r() * 240; y < SH; y += 220 + r() * 140) { var v = 0.8 + r() * 0.3; g.fillStyle = 'rgb(' + (170 * v | 0) + ',' + (118 * v | 0) + ',' + (74 * v | 0) + ')'; g.fillRect(x, y, 62, 400); }
      } else if (name === 'white') {
        g.fillStyle = '#e8e6e2'; g.fillRect(0, 0, SW, SH);
        for (var x2 = 0; x2 < SW; x2 += 120) for (var y2 = 0; y2 < SH; y2 += 120) { g.strokeStyle = 'rgba(0,0,0,.07)'; g.strokeRect(x2, y2, 120, 120); }
      } else {
        for (var x3 = 0; x3 < SW; x3++) { var s = 0.72 + 0.28 * Math.sin(x3 / 14) * Math.sin(x3 / 53 + 1); g.fillStyle = 'rgb(' + (230 * s | 0) + ',' + (222 * s | 0) + ',' + (214 * s | 0) + ')'; g.fillRect(x3, 0, 1, SH); }
      }
      surf[name] = c; return c;
    }
    var L = document.createElement('canvas'); L.width = SW; L.height = SH; var Lg = L.getContext('2d');
    function draw() {
      drawArt();
      tg.clearRect(0, 0, N, N); tg.globalCompositeOperation = 'source-over'; tg.drawImage(art, 0, 0);
      tg.globalCompositeOperation = 'source-in'; tg.fillStyle = st.color; tg.fillRect(0, 0, N, N); tg.globalCompositeOperation = 'source-over';
      var floor = st.surface !== 'drape', size = (sizeIn ? +sizeIn.value : 78) / 100;
      Lg.setTransform(1, 0, 0, 1, 0, 0); Lg.globalCompositeOperation = 'source-over';
      Lg.fillStyle = 'rgb(34,31,40)'; Lg.fillRect(0, 0, SW, SH);
      Lg.save(); Lg.translate(SW / 2, SH / 2); if (floor) Lg.scale(1, 0.6);
      var D = SH * size * (floor ? 1.55 : 1.02);
      var halo = Lg.createRadialGradient(0, 0, D * 0.2, 0, 0, D * 0.62); halo.addColorStop(0, 'rgba(255,240,215,.16)'); halo.addColorStop(1, 'rgba(255,240,215,0)');
      Lg.fillStyle = halo; Lg.beginPath(); Lg.arc(0, 0, D * 0.62, 0, Math.PI * 2); Lg.fill();
      Lg.globalCompositeOperation = 'lighter'; Lg.filter = 'blur(0.8px)';
      Lg.drawImage(tint, -D / 2, -D / 2, D, D); Lg.filter = 'none';
      Lg.restore();
      ctx.globalCompositeOperation = 'source-over'; ctx.drawImage(surface(st.surface), 0, 0);
      ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(L, 0, 0);
      ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = 0.35; ctx.drawImage(L, 0, 0); ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
      var vg = ctx.createRadialGradient(SW / 2, SH / 2, SH * 0.35, SW / 2, SH / 2, SW * 0.72); vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,.6)');
      ctx.fillStyle = vg; ctx.fillRect(0, 0, SW, SH);
    }
    function save(canvas, name) { try { var x = document.createElement('a'); x.download = name; x.href = canvas.toDataURL('image/png'); document.body.appendChild(x); x.click(); x.remove(); } catch (e) { toast('<span>Your browser blocked the download. Right-click the image to save it.</span>'); } }
    var dA = $('[data-act="art"]', el), dP = $('[data-act="preview"]', el);
    if (dA) dA.addEventListener('click', function () {
      drawArt(); var c = document.createElement('canvas'); c.width = c.height = 1200; var g = c.getContext('2d');
      g.fillStyle = '#000'; g.fillRect(0, 0, 1200, 1200); g.drawImage(art, 0, 0, 1200, 1200); save(c, 'monogram-artwork.png');
    });
    if (dP) dP.addEventListener('click', function () { save(stage, 'monogram-preview.png'); });
    draw();
    if (document.fonts) {
      Promise.all([document.fonts.load('200px "Great Vibes"'), document.fonts.load('italic 500 40px "Playfair Display"'), document.fonts.load('500 30px Oswald')]).then(draw, draw);
      setTimeout(draw, 1500);
    }
  };

  /* Rent vs own for gobo / monogram lighting */
  T['rent-own'] = function (el) {
    var ev = $('[data-in="events"]', el), rp = $('[data-in="rental"]', el), evO = $('[data-out="events"]', el), rpO = $('[data-out="rental"]', el), out = $('[data-out="result"]', el), vd = $('[data-out="verdict"]', el), bars = $('[data-out="bars"]', el);
    var own = null;
    getProduct('innaya-g10-gobo-projector').then(function (p) { var v = p.variants.filter(function (x) { return /60/.test(x.title); })[0] || p.variants[0]; own = v.price / 100; calc(); }).catch(function () { own = 236.31; calc(); });
    [ev, rp].forEach(function (i) { i.addEventListener('input', calc); });
    function calc() {
      var n = +ev.value, r = +rp.value;
      evO.textContent = n + (n === 1 ? ' event' : ' events'); rpO.textContent = '$' + r + ' per event';
      if (own == null) return;
      var rent = n * r, be = Math.ceil(own / r);
      out.innerHTML = '<div><small>Renting ' + n + '×</small><b>$' + num(rent) + '</b></div><div><small>Owning a G10 60 W</small><b>$' + num(own, 0) + '</b></div><div><small>Break-even</small><b>' + be + '<em>event' + (be > 1 ? 's' : '') + '</em></b></div>';
      var mx = Math.max(rent, own);
      bars.innerHTML = '<div class="inx-bar"><span>Rent</span><i style="width:' + (rent / mx * 100) + '%"></i></div><div class="inx-bar inx-bar--own"><span>Own</span><i style="width:' + (own / mx * 100) + '%"></i></div>';
      var cls = rent > own ? 'is-good' : rent === own ? 'is-warn' : 'is-warn';
      var msg = rent > own ? '<b>Owning wins by $' + num(rent - own) + '.</b> And after the last event, the projector is still yours: for the anniversary, the next family wedding, or the patio.' :
        '<b>For ' + (n === 1 ? 'a single event' : 'this few events') + ', renting is about $' + num(own - rent) + ' cheaper.</b> The gap is small, and a rental goes back in the box. If there’s a chance you’ll use it again, owning pays off at ' + be + ' events.';
      vd.className = 'inx-verdict ' + cls; vd.innerHTML = '<span class="inx-verdict__dot"></span><span>' + msg + '</span>';
    }
  };

  /* ===== tool: 60-sign-sizer ===== */
  /* Holographic sign sizer: viewing distance + content -> fan size, with an apparent-size view. */
  T['sign-sizer'] = function (el) {
    var dIn = $('[data-in="dist"]', el), dOut = $('[data-out="dist"]', el), svg = $('svg[data-view]', el), rec = $('[data-out="rec"]', el), cards = $('[data-out="cards"]', el);
    var unit = store.get('unit', 'ft'), content = 'text', place = 'window', meters = 5;
    // image diameters (m): fan span; H-PRO uses its width for text, height for image impact
    var FANS = [
      { id: 'h16', name: 'H16', handle: 'innaya-3d-advertising-hologram-fan', d: 0.41, dImg: 0.41, label: '16 in' },
      { id: 'h23', name: 'H23', handle: 'innaya-h23-3d-advertising-hologram-fan', d: 0.58, dImg: 0.58, label: '23 in' },
      { id: 'h39', name: 'H39', handle: 'innaya-h20-3d-advertising-hologram-fan', d: 0.99, dImg: 0.99, label: '39 in' },
      { id: 'hpro', name: 'H-PRO', handle: 'innaya-h-pro-3d-advertising-hologram-fan', d: 0.6, dImg: 1.46, label: '60 × 146 cm' },
      { id: 'wall', name: '9-fan wall', handle: 'innaya-65cm-9-piece-3d-hologram-fan-wall', d: 1.55, dImg: 1.55, label: '155 × 155 cm' }
    ];
    // comfortable viewing reach: text ~ 11x image size (1 in letter per 10 ft rule), imagery ~ 22x
    function reach(f) { return content === 'text' ? f.d * 11 : f.dImg * 22; }
    seg($('[data-in="unit"]', el), function (v) { unit = v; store.set('unit', v); syncUnit(); });
    $$('[data-in="unit"] button', el).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === unit ? 'true' : 'false'); });
    seg($('[data-in="content"]', el), function (v) { content = v; draw(); });
    seg($('[data-in="place"]', el), function (v) { place = v; draw(); });
    dIn.addEventListener('input', function () { meters = unit === 'ft' ? +dIn.value / 3.28084 : +dIn.value; draw(); });
    function fmt(m) { return unit === 'ft' ? num(m * 3.28084, 0) + ' ft' : num(m, m < 10 ? 1 : 0) + ' m'; }
    function syncUnit() {
      if (unit === 'ft') { dIn.min = 3; dIn.max = 80; dIn.step = 1; dIn.value = Math.round(meters * 3.28084); }
      else { dIn.min = 1; dIn.max = 25; dIn.step = 0.5; dIn.value = Math.round(meters * 2) / 2; }
      paintRange(dIn); draw();
    }
    var lastPick = null, lastPlace = null;
    function draw() {
      dOut.textContent = fmt(meters);
      var pool = FANS.slice();
      if (place === 'counter') pool = pool.filter(function (f) { return f.id === 'h16' || f.id === 'h23'; });
      var pick = pool.filter(function (f) { return reach(f) >= meters; })[0] || pool[pool.length - 1];
      var enough = reach(pick) >= meters;
      // --- apparent size view: 24 degree window across 600px
      var W = 900, H = 330, fov = 24 * Math.PI / 180, pxPerRad = 560 / fov;
      var out = '<rect width="' + W + '" height="' + H + '" fill="#060708"/>' +
        '<text x="24" y="32" fill="#9a9a9a" font-size="16" font-family="Oswald, sans-serif" letter-spacing="2">HOW BIG EACH FAN LOOKS FROM ' + fmt(meters).toUpperCase() + '</text>';
      var shown = FANS.filter(function (f) { return f.id !== 'hpro'; });
      var x = 70;
      shown.forEach(function (f) {
        var ang = 2 * Math.atan(f.d / 2 / meters), r = Math.max(2, ang * pxPerRad / 2);
        r = Math.min(r, 112);
        var cx = x + 60, cy = 175, on = f.id === pick.id;
        out += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + (on ? 'rgba(164,206,222,.10)' : 'rgba(255,255,255,.03)') + '" stroke="' + (on ? '#a4cede' : '#3a3a3a') + '" stroke-width="' + (on ? 2 : 1) + '"/>';
        if (content === 'text') {
          var fs = r * 0.36;
          out += '<text x="' + cx + '" y="' + (cy + fs * 0.35) + '" fill="' + (on ? '#fff' : '#9a9a9a') + '" font-family="Poppins, sans-serif" font-weight="700" font-size="' + fs + '" text-anchor="middle">SALE 30%</text>';
        } else {
          out += '<g transform="translate(' + cx + ' ' + cy + ') scale(' + (r / 60) + ')" fill="none" stroke="' + (on ? '#ef6c00' : '#666') + '" stroke-width="' + (6 / Math.max(0.2, r / 60)) + '"><path d="M-34 14 L-22 -18 L6 -18 L30 2 L34 14 Z"/><circle cx="-18" cy="18" r="9"/><circle cx="22" cy="18" r="9"/></g>';
        }
        out += '<text x="' + cx + '" y="' + 305 + '" fill="' + (on ? '#a4cede' : '#777') + '" font-size="14" font-family="Poppins, sans-serif" font-weight="' + (on ? 600 : 400) + '" text-anchor="middle">' + f.name + '</text>';
        x += Math.max(140, r * 2 + 40);
      });
      svg.setAttribute('viewBox', '0 0 ' + Math.max(W, x + 20) + ' ' + H);
      svg.innerHTML = out;
      var tips = {
        window: 'Hang it 20–50 cm behind the glass so reflections don’t sit on top of the image. From inside the shop it reads mirrored, which is fine for a window.',
        counter: 'At arm’s length the blades need a guard. Use the protective case, or mount it above head height on the wall behind the counter.',
        ceiling: 'The Vantage Plus bracket hangs H16–H39 fans from the ceiling. Tilt it slightly down toward the aisle for the brightest image.',
        booth: 'Booths are seen from across the aisle, often 4–8 m. Size for the far side, and consider linking fans into a wall.',
        outdoor: 'Keep fans out of rain and direct sun: under a canopy, in a covered entrance, or behind glass. Check your local sign code for animated signs.'
      };
      rec.innerHTML = '<span class="inx-card__tag">' + (enough ? 'Recommended size' : 'Largest option for this spot') + '</span>' +
        '<h3 class="inx-h3" style="font-size:24px">' + pick.name + ' <span class="inx-muted" style="font-weight:400;font-size:18px">(' + pick.label + ')</span></h3>' +
        '<p class="inx-rec-why">' + (enough ? (content === 'text' ? 'Short text on the ' + pick.name + ' stays comfortably readable out to about ' + fmt(reach(pick)) + '.' : 'Product images on the ' + pick.name + ' stay recognizable out to about ' + fmt(reach(pick)) + '.') : 'At ' + fmt(meters) + ' even this is working hard for ' + (content === 'text' ? 'text. Switch to imagery, cut the message to one or two words, or link several fans.' : 'imagery. Link more fans for a bigger canvas.')) + ' ' + tips[place] + '</p>';
      if (lastPick !== pick.id || lastPlace !== place) {
        lastPick = pick.id;
        lastPlace = place;
        var list = [[pick.handle, 'Best fit', '']];
        if (place === 'ceiling') list.push(['h-series-vantage-plus-ceiling-hanging-bracket', 'Mount', 'Hangs H16 to H39 fans.', '', '', pick.id === 'h39' ? 'Models H39"' : 'Models H16” to H23”']);
        if (place === 'counter' || place === 'booth') list.push(['h-series-projector-protective-shield', 'Guard', 'Covers the blades and quiets the motor.', '', '', pick.id === 'h23' ? 'H23' : 'H16”']);
        if (pick.id === 'h23' || pick.id === 'h39') list.push(['innaya-h-series-multi-fan-linking-router', 'Grow later', 'Links H23 and larger fans into one picture.']);
        cards.innerHTML = list.map(function (c) { return cardHTML(c[0], c[1], c[2], c[3], c[4], c[5]); }).join('');
        cards.className = 'inx-products' + (list.length > 2 ? ' inx-products--3' : '');
        mountCards(cards);
      }
    }
    syncUnit();
  };

  /* ===== tool: 70-ad-tools ===== */
  /* Hologram fan advertising: ROI / payback calculator (every input is the merchant's own assumption). */
  T.roi = function (el) {
    var ins = {}, outs = {};
    ['traffic', 'notice', 'act', 'buy', 'ticket', 'margin'].forEach(function (k) { ins[k] = $('[data-in="' + k + '"]', el); outs[k] = $('[data-out="' + k + '"]', el); ins[k].addEventListener('input', calc); });
    var res = $('[data-out="result"]', el), vd = $('[data-out="verdict"]', el);
    var model = 'innaya-h23-3d-advertising-hologram-fan', price = {};
    seg($('[data-in="fan"]', el), function (v) { model = v; calc(); });
    ['innaya-3d-advertising-hologram-fan', 'innaya-h23-3d-advertising-hologram-fan', 'innaya-h20-3d-advertising-hologram-fan', 'innaya-h-pro-3d-advertising-hologram-fan'].forEach(function (h) {
      getProduct(h).then(function (p) { price[h] = p.variants[0].price / 100; calc(); }).catch(function () {});
    });
    function calc() {
      var t = +ins.traffic.value, n = +ins.notice.value / 100, a = +ins.act.value / 100, b = +ins.buy.value / 100, tk = +ins.ticket.value, m = +ins.margin.value / 100;
      outs.traffic.textContent = num(t) + ' / day'; outs.notice.textContent = Math.round(n * 100) + '%'; outs.act.textContent = (a * 100).toFixed(a < 0.1 ? 1 : 0) + '%';
      outs.buy.textContent = Math.round(b * 100) + '%'; outs.ticket.textContent = '$' + num(tk); outs.margin.textContent = Math.round(m * 100) + '%';
      var sales = t * n * a * b, gp = sales * tk * m, month = gp * 30.4, p = price[model];
      var days = p ? p / Math.max(gp, 0.0001) : null;
      res.innerHTML = '<div><small>Extra sales per day</small><b>' + num(sales, sales < 10 ? 1 : 0) + '</b></div>' +
        '<div><small>Extra gross profit / month</small><b>$' + num(month) + '</b></div>' +
        '<div><small>Display pays for itself in</small><b>' + (days == null ? '—' : days > 365 ? '1 yr+' : Math.ceil(days) + '<em>days</em>') + '</b></div>';
      var cls = days == null ? '' : days <= 60 ? 'is-good' : days <= 180 ? 'is-warn' : 'is-bad';
      var msg = days == null ? 'Loading today’s price…' : days <= 60 ? '<b>On these numbers it pays back inside two months.</b> Now prove it: run an offer that only the display shows, and count redemptions for four weeks.' :
        days <= 180 ? '<b>A slower payback, but a real one.</b> Placement is usually the lever. Move it to where more people pass, or sharpen the offer.' :
        '<b>On these numbers it’s a long payback.</b> A hologram fan needs foot traffic to work. If your street is quiet, a smaller model, or a window display used for seasonal pushes only, makes more sense.';
      vd.className = 'inx-verdict ' + cls; vd.innerHTML = '<span class="inx-verdict__dot"></span><span>' + msg + '</span>';
    }
    calc();
  };

  /* Ad loop storyboard: pick a business type, get a 4-beat loop plus matching ready-made animations. */
  T.storyboard = function (el) {
    var tl = $('[data-out="timeline"]', el), beats = $('[data-out="beats"]', el), shelf = $('[data-out="shelf"]', el);
    var CDN = 'https://cdn.shopify.com/s/files/1/0832/9835/3454/files/';
    var LIB = {
      burger: ['burger', 49009796710702, 'innaya_3D_Burger.gif', 'Burger'], coffee: ['coffee', 49009809064238, 'innaya_3D_Coffee.gif', 'Coffee'], pizza: ['pizza-2', 49009867587886, 'innaya_3D_Pizza_2.gif', 'Pizza'], donut: ['doughnut', 49009825055022, 'innaya_3d_Doughnut.gif', 'Doughnut'], sandwich: ['sandwich', 49009868505390, 'innaya_3D_Sandwich.gif', 'Sandwich'],
      shoe: ['shoe-1', 49009869783342, 'innaya_3D_Shoe_1.gif', 'Sneaker'], shoe2: ['shoe-3', 49009870373166, 'innaya_Shoe_2.gif', 'Runner'], cap: ['cap', 49009802707246, 'innaya_3D_Cap.gif', 'Cap'],
      diamond: ['diamond-1', 49009812898094, 'innaya_3D_Diamond_1.gif', 'Diamond'], ring: ['mens-ring-1', 49009864343854, 'innaya_3D_Mens_Ring_1.gif', 'Ring'], rings: ['flying-cluster-of-rings', 49009847533870, 'innaya_3D_Flying_Cluster_of_Rings.gif', 'Flying rings'],
      coins: ['raining-coins', 49009867784494, 'innaya_3D_Raining_Coins.gif', 'Raining coins'], coin: ['coin', 49009809686830, 'innaya_3D_Coin.gif', 'Coin'],
      flower: ['flower', 49009847402798, 'innaya_3D_Flower.gif', 'Flower'], butterfly: ['butterfly-2', 49009801658670, 'innaya_3D_Butterfly_2.gif', 'Butterfly'], heart: ['heart', 49009848090926, 'innaya_3D_Heart.gif', 'Heart'], apple: ['floating-apple', 49009847271726, 'innaya_3D_Floating_Apple.gif', 'Apple'], berries: ['strawberries', 49009872503086, 'innaya_Strawberries.gif', 'Strawberries']
    };
    var T0 = {
      food: { beats: [['Hook', 3, 'A burger builds itself in mid-air. Motion first; people turn their heads for it.'], ['Offer', 3, 'Two or three words, big: “Lunch $9.99”. Hold it long enough to read.'], ['Craving', 2, 'A second item turning slowly: coffee, pizza, dessert.'], ['Brand', 2, 'Your logo, still, then the loop restarts.']], lib: ['burger', 'coffee', 'pizza', 'donut', 'sandwich'] },
      retail: { beats: [['Hook', 3, 'The hero product spinning. A sneaker or cap reads instantly from the sidewalk.'], ['News', 2, '“Just in” or “New season”. One line only.'], ['Offer', 3, 'The reason to come in today: “20% off inside”.'], ['Brand', 2, 'Logo, and the loop resets.']], lib: ['shoe', 'shoe2', 'cap', 'coins'] },
      jewelry: { beats: [['Hook', 3, 'A diamond turning under the “light”. The sparkle does the work.'], ['Piece', 3, 'The ring or piece of the month, slow rotation.'], ['Moment', 2, '“She said yes”, “Anniversary?” or a heart.'], ['Brand', 2, 'Your name, still.']], lib: ['diamond', 'ring', 'rings', 'heart'] },
      sale: { beats: [['Hook', 2, 'Coins raining down. Everyone understands it without reading.'], ['Offer', 4, 'The number, huge: “50% OFF”.'], ['Urgency', 2, '“This weekend only”.'], ['Brand', 2, 'Logo, loop.']], lib: ['coins', 'coin', 'heart'] },
      beauty: { beats: [['Hook', 3, 'A flower opening or a butterfly in flight: soft, colorful motion.'], ['Service', 3, 'What you do, in three words: “Walk-ins welcome”.'], ['Offer', 2, 'First-visit offer or a seasonal treatment.'], ['Brand', 2, 'Logo, loop.']], lib: ['flower', 'butterfly', 'heart', 'berries', 'apple'] }
    };
    var cur = 'food';
    seg($('[data-in="biz"]', el), function (v) { cur = v; draw(); });
    function draw() {
      var tpl = T0[cur], total = tpl.beats.reduce(function (s, b) { return s + b[1]; }, 0), colors = ['#a4cede', '#ef6c00', '#6f8f9b', '#3c3c3c'];
      tl.innerHTML = tpl.beats.map(function (b, i) { return '<div class="inx-tl__seg" style="flex:' + b[1] + ';background:' + colors[i] + '"><b>' + esc(b[0]) + '</b><span>' + b[1] + 's</span></div>'; }).join('') + '<div class="inx-tl__total">' + total + ' s loop</div>';
      beats.innerHTML = tpl.beats.map(function (b, i) { return '<li class="ok"><span><b>' + (i + 1) + '. ' + esc(b[0]) + ' (' + b[1] + ' s).</b> ' + esc(b[2]) + '</span></li>'; }).join('');
      shelf.innerHTML = tpl.lib.map(function (k) {
        var it = LIB[k];
        return '<figure class="inx-gif"><a href="' + R + 'products/' + it[0] + '"><img src="' + CDN + it[2] + '" alt="INNAYA ready-made 3D animation: ' + esc(it[3]) + '" loading="lazy" width="200" height="200"></a><figcaption><span>' + esc(it[3]) + '</span><button type="button" class="inx-gif__add" data-v="' + it[1] + '" data-t="3D Content: ' + esc(it[3]) + '">Add</button></figcaption></figure>';
      }).join('');
      $$('.inx-gif__add', shelf).forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = '…';
          addToCart(b.getAttribute('data-v'), 1).then(function () { b.textContent = 'Added'; cartToast(b.getAttribute('data-t')); }).catch(function (e) { b.disabled = false; b.textContent = 'Add'; toast('<span>' + esc(e.message) + '</span>'); });
        });
      });
    }
    draw();
  };

  /* ===== tool: 80-file-check ===== */
  /* Hologram fan file checker: reads a local video/image, checks format, shape, background and edges,
     and previews it inside a spinning-fan mask. Nothing is uploaded. */
  T['file-check'] = function (el) {
    var input = $('input[type="file"]', el), drop = $('[data-drop]', el), list = $('[data-out="checks"]', el), meta = $('[data-out="meta"]', el);
    var cv = $('canvas[data-stage]', el), ctx = cv.getContext('2d'), W = cv.width;
    var an = document.createElement('canvas'); an.width = an.height = 200; var ag = an.getContext('2d', { willReadFrequently: true });
    var media = null, isVideo = false, angle = 0, raf = null, last = 0;
    function pick() { input && input.click(); }
    if (drop) {
      drop.addEventListener('click', pick);
      drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) load(f); });
    }
    if (input) input.addEventListener('change', function () { if (input.files[0]) load(input.files[0]); });

    function row(cls, title, text) { return '<li class="' + cls + '"><span><b>' + title + '</b> ' + text + '</span></li>'; }
    function load(f) {
      cancelAnimationFrame(raf); media = null;
      var name = f.name || 'file', ext = (name.split('.').pop() || '').toLowerCase(), mb = f.size / 1048576;
      var fanOK = ['mp4', 'avi', 'rmvb', 'jpg', 'jpeg'].indexOf(ext) > -1;
      var rows = [];
      rows.push(fanOK ? row('ok', 'Format: .' + ext + '.', 'INNAYA fans play MP4, AVI, RMVB and JPG.') :
        row('bad', 'Format: .' + (ext || '?') + '.', 'The fan won’t play this directly. Convert to MP4 (H.264). The free app HandBrake does it in a couple of clicks.' + (ext === 'png' ? ' For a still image, save it as JPG.' : '')));
      rows.push(mb > 300 ? row('warn', 'Size: ' + num(mb, 0) + ' MB.', 'Large files are slow to send over the fan’s Wi-Fi. Trim to a short loop, or copy it to the SD card instead.') : row('ok', 'Size: ' + (mb < 1 ? num(f.size / 1024, 0) + ' KB.' : num(mb, mb < 10 ? 1 : 0) + ' MB.'), 'Fine to send from your phone.'));
      meta.textContent = name;
      var url = URL.createObjectURL(f);
      if (/^video\//.test(f.type) || ['mp4', 'mov', 'webm', 'avi', 'mkv', 'm4v', 'rmvb'].indexOf(ext) > -1) {
        isVideo = true;
        var v = document.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto'; v.src = url;
        v.onerror = function () {
          rows.push(row('warn', 'Can’t preview here.', 'Your browser can’t decode this file' + (ext === 'avi' || ext === 'rmvb' ? ', which is normal for ' + ext.toUpperCase() + '. The fan can still play it, but we can’t check the picture. Convert a copy to MP4 if you’d like a preview.' : '. It may use a codec such as HEVC (H.265). Convert it to MP4 with H.264 video to be safe on the fan too.')));
          list.innerHTML = rows.join('');
        };
        v.onloadedmetadata = function () {
          var d = v.duration, w = v.videoWidth, h = v.videoHeight;
          rows.push(d < 3 ? row('warn', 'Length: ' + num(d, 1) + ' s.', 'Very short loops can feel jumpy. 6–15 seconds is the sweet spot for ads.') : d > 60 ? row('warn', 'Length: ' + num(d, 0) + ' s.', 'Fine for the fan, but passers-by only give you a few seconds. A short loop gets the message across more often.') : row('ok', 'Length: ' + num(d, 1) + ' s.', 'A good loop length.'));
          sampleFrames(v, [0.12, 0.5, 0.88], function (stats) { finish(rows, w, h, stats); v.play().catch(function () {}); media = v; loop(); });
        };
      } else if (/^image\//.test(f.type)) {
        isVideo = false;
        var im = new Image(); im.onload = function () { var s = analyse(im, im.naturalWidth, im.naturalHeight); finish(rows, im.naturalWidth, im.naturalHeight, [s]); media = im; loop(); };
        im.onerror = function () { rows.push(row('bad', 'Unreadable image.', 'Try re-saving it as a JPG.')); list.innerHTML = rows.join(''); };
        im.src = url;
      } else { list.innerHTML = rows.join(''); return; }
      list.innerHTML = rows.join('') + '<li><span>Analyzing the picture…</span></li>';
    }
    function sampleFrames(v, marks, done) {
      var out = [], i = 0;
      function next() {
        if (i >= marks.length) { done(out); return; }
        var t = Math.max(0, Math.min(v.duration - 0.05, v.duration * marks[i]));
        var onSeek = function () { v.removeEventListener('seeked', onSeek); out.push(analyse(v, v.videoWidth, v.videoHeight)); i++; next(); };
        v.addEventListener('seeked', onSeek); v.currentTime = t;
      }
      next();
    }
    // draw fitted into 200x200 and measure: background darkness, gray haze, content outside the circle
    function analyse(src, w, h) {
      var S = 200, s = Math.min(S / w, S / h), dw = w * s, dh = h * s;
      ag.fillStyle = '#000'; ag.fillRect(0, 0, S, S); ag.drawImage(src, (S - dw) / 2, (S - dh) / 2, dw, dh);
      var d = ag.getImageData(0, 0, S, S).data, c = S / 2, R = S / 2;
      var bgPure = 0, bgGray = 0, bgN = 0, outside = 0, outN = 0, subj = 0, subjSum = 0;
      for (var y = 0; y < S; y++) for (var x = 0; x < S; x++) {
        var q = (y * S + x) * 4, L = d[q] * 0.2126 + d[q + 1] * 0.7152 + d[q + 2] * 0.0722, r2 = (x - c) * (x - c) + (y - c) * (y - c);
        var inFrame = x >= (S - dw) / 2 && x < (S + dw) / 2 && y >= (S - dh) / 2 && y < (S + dh) / 2;
        if (!inFrame) continue;
        if (r2 > R * R) { outN++; if (L > 40) outside++; }
        if (L < 45) { bgN++; if (L < 7) bgPure++; else bgGray++; } else { subj++; subjSum += L; }
      }
      return { pure: bgN ? bgPure / bgN : 1, gray: bgN ? bgGray / bgN : 0, outside: outN ? outside / outN : 0, cover: subj / (dw * dh), bright: subj ? subjSum / subj : 0 };
    }
    function finish(rows, w, h, stats) {
      var avg = function (k) { return stats.reduce(function (s, x) { return s + x[k]; }, 0) / stats.length; };
      var ratio = w / h, short = Math.min(w, h);
      rows.push(Math.abs(ratio - 1) < 0.04 ? row('ok', 'Shape: ' + w + ' × ' + h + ' (square).', 'Perfect for a round display.') :
        row('warn', 'Shape: ' + w + ' × ' + h + '.', 'The fan shows a circle, so the ' + (ratio > 1 ? 'left and right edges' : 'top and bottom') + ' of a non-square video are wasted or cut. Crop to a square with your subject centered.'));
      rows.push(short >= 1000 ? row('ok', 'Resolution.', 'Plenty of detail.') : short >= 500 ? row('ok', 'Resolution.', 'Good enough. 1024 × 1024 is ideal.') : row('warn', 'Low resolution.', 'Under 500 px looks soft on larger fans. Export at 1024 × 1024 if you can.'));
      var gray = avg('gray'), pure = avg('pure');
      rows.push(gray > 0.35 ? row('bad', 'Background isn’t pure black.', 'About ' + Math.round(gray * 100) + '% of the dark area is dark gray, which lights up as a faint disc and breaks the floating effect. Set the background to #000000.') :
        gray > 0.12 ? row('warn', 'Background is nearly black.', 'Some dark-gray areas (about ' + Math.round(gray * 100) + '%). Crush the blacks in your editor for a cleaner float.') : row('ok', 'Background is pure black.', 'That’s what makes it float.'));
      var out = avg('outside');
      rows.push(out > 0.06 ? row('warn', 'Content near the corners.', 'Bright pixels sit outside the round display area and will be cut off. Shrink or center the subject.') : row('ok', 'Nothing important outside the circle.', ''));
      var cover = avg('cover');
      rows.push(cover < 0.04 ? row('warn', 'Subject is tiny or very dark.', 'It may be hard to see from a distance. Scale it up to fill most of the circle.') : cover > 0.75 ? row('warn', 'Almost no black space.', 'A full-frame video looks like a spinning disc rather than a floating object. Isolate the subject on black.') : row('ok', 'Good subject size.', ''));
      list.innerHTML = rows.join('');
    }
    var vis = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: 0.02 }).observe(cv);
    function loop(ts) {
      raf = requestAnimationFrame(loop);
      if (!vis) return;
      var dt = ts && last ? (ts - last) / 1000 : 0.016; last = ts || 0;
      angle += dt * 13;
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, W);
      ctx.save(); ctx.beginPath(); ctx.arc(W / 2, W / 2, W * 0.46, 0, Math.PI * 2); ctx.clip();
      if (media) {
        var mw = isVideo ? media.videoWidth : media.naturalWidth, mh = isVideo ? media.videoHeight : media.naturalHeight;
        if (mw && mh) { var s = Math.max(W * 0.92 / mw, W * 0.92 / mh); ctx.drawImage(media, (W - mw * s) / 2, (W - mh * s) / 2, mw * s, mh * s); }
      }
      // faint blades + slight scanline shimmer so it reads as a fan, not a screen
      ctx.globalCompositeOperation = 'lighter';
      for (var b = 0; b < 4; b++) {
        var a = angle + b * Math.PI / 2;
        ctx.strokeStyle = 'rgba(255,255,255,.05)'; ctx.lineWidth = 10;
        ctx.beginPath(); ctx.moveTo(W / 2, W / 2); ctx.lineTo(W / 2 + Math.cos(a) * W * 0.46, W / 2 + Math.sin(a) * W * 0.46); ctx.stroke();
      }
      ctx.globalCompositeOperation = 'source-over';
      ctx.restore();
      ctx.strokeStyle = '#1e1e1e'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(W / 2, W / 2, W * 0.46, 0, Math.PI * 2); ctx.stroke();
      ctx.fillStyle = '#161616'; ctx.beginPath(); ctx.arc(W / 2, W / 2, W * 0.035, 0, Math.PI * 2); ctx.fill();
      if (!media) {
        ctx.fillStyle = '#7a7a7a'; ctx.font = '500 ' + Math.round(W * 0.035) + 'px Poppins, sans-serif'; ctx.textAlign = 'center';
        ctx.fillText('Your video appears here', W / 2, W / 2 + W * 0.1);
      }
    }
    loop();
  };

  /* ===== tool: 90-xmas ===== */
  /* Christmas window scene: pick a loop and a fan size, see it floating in a shop window at night. */
  T['xmas-window'] = function (el) {
    var holo = $('[data-holo]', el), img = $('img', holo), win = $('[data-window]', el), snow = $('canvas[data-snow]', el), add = $('[data-out="add"]', el);
    var CDN = 'https://cdn.shopify.com/s/files/1/0832/9835/3454/files/';
    var LOOPS = {
      santa: ['innaya_3d_Merry_Christmas.gif', 49009864737070, 'Santa', 'merry-christmas'],
      diamond: ['innaya_3D_Diamond_1.gif', 49009812898094, 'Diamond', 'diamond-1'],
      coins: ['innaya_3D_Raining_Coins.gif', 49009867784494, 'Raining coins', 'raining-coins'],
      heart: ['innaya_3D_Heart.gif', 49009848090926, 'Heart', 'heart']
    };
    var SIZE = { h16: 0.41, h23: 0.58, h39: 0.99 }, WIN_M = 1.6; // the drawn window is about 1.6 m wide
    var st = { loop: 'santa', size: 'h23' };
    seg($('[data-in="loop"]', el), function (v) { st.loop = v; paint(); });
    seg($('[data-in="size"]', el), function (v) { st.size = v; paint(); });
    seg($('[data-in="time"]', el), function (v) { el.setAttribute('data-time', v); });
    function paint() {
      var L = LOOPS[st.loop];
      img.src = CDN + L[0]; img.alt = 'INNAYA 3D content: ' + L[2] + ', shown floating in a shop window';
      holo.style.width = (SIZE[st.size] / WIN_M * 100) + '%';
      if (add) {
        add.innerHTML = '<button type="button" class="inx-btn inx-btn--buy">Add the ' + esc(L[2]) + ' loop to cart</button>' +
          '<a class="inx-btn inx-btn--ghost" href="' + R + 'products/' + L[3] + '">Preview the loop</a>';
        var b = $('button', add);
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = 'Adding…';
          addToCart(L[1], 1).then(function () { b.textContent = 'Added ✓'; cartToast('3D Content: ' + L[2]); }).catch(function (e) { b.disabled = false; b.textContent = 'Try again'; toast('<span>' + esc(e.message) + '</span>'); });
        });
      }
    }
    // snowfall
    if (snow) {
      var sc = snow.getContext('2d'), flakes = [], vis = true, W = 0, H = 0;
      function size() { W = snow.width = snow.offsetWidth; H = snow.height = snow.offsetHeight; }
      size(); window.addEventListener('resize', size);
      for (var i = 0; i < 90; i++) flakes.push({ x: Math.random(), y: Math.random(), r: 0.6 + Math.random() * 2.2, s: 0.2 + Math.random() * 0.6, d: Math.random() * 6 });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }).observe(snow);
      (function tick(t) {
        requestAnimationFrame(tick);
        if (!vis || reduceMotion) return;
        sc.clearRect(0, 0, W, H); sc.fillStyle = 'rgba(255,255,255,.85)';
        flakes.forEach(function (f) {
          f.y += f.s / 400; f.x += Math.sin(t / 1400 + f.d) / 2400;
          if (f.y > 1.02) { f.y = -0.02; f.x = Math.random(); }
          sc.beginPath(); sc.arc(f.x * W, f.y * H, f.r, 0, Math.PI * 2); sc.fill();
        });
      })(0);
    }
    paint();
  };

  /* Countdown to Christmas with a practical "set up by" note */
  T.countdown = function (el) {
    var out = $('[data-out="days"]', el), note = $('[data-out="note"]', el);
    var now = new Date(), y = now.getFullYear();
    var xmas = new Date(y, 11, 25); if (now > new Date(y, 11, 26)) xmas = new Date(y + 1, 11, 25);
    var days = Math.ceil((xmas - now) / 86400000);
    out.textContent = days;
    var nov1 = new Date(xmas.getFullYear(), 10, 1), start = now > nov1 ? now : nov1;
    var weeks = Math.round((xmas - start) / 604800000) + 1;
    if (note) note.textContent = days > 40 ? 'Set up by the start of November and your window works through Black Friday, Small Business Saturday and every December weekend. That’s about ' + (weeks - 1) + ' weeks of holiday traffic.' : days > 14 ? 'There’s still time for several busy weekends. Order now and check our shipping page for current delivery times.' : 'Tight, but not over. Check current delivery times on our shipping page, then plan the loop for New Year and January sales.';
  };

  /* ===== tool: 95-hub ===== */
  /* Guides hub filter */
  T.hub = function (el) {
    var cards = $$('[data-cat]', el), chips = $$('[data-filter]', el), count = $('[data-out="count"]', el);
    chips.forEach(function (c) {
      c.type = 'button';
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        var f = c.getAttribute('data-filter'), n = 0;
        cards.forEach(function (k) { var on = f === 'all' || k.getAttribute('data-cat').indexOf(f) > -1; k.hidden = !on; if (on) n++; });
        if (count) count.textContent = n + (n === 1 ? ' guide' : ' guides');
      });
    });
  };


  $$('[data-inx-tool]', root).forEach(function (el) {
    var name = el.getAttribute('data-inx-tool');
    if (T[name]) { try { T[name](el); } catch (e) { if (window.console) console.error('[inx] tool ' + name, e); } }
  });
})();
